import React, { useState, useRef, useEffect, useMemo } from "react"
import { Col, Container, Row } from "reactstrap"
import { InputMask } from "primereact/inputmask"
import { Dropdown } from "primereact/dropdown"
import { TabView, TabPanel } from "primereact/tabview"
import { Link, useLocation } from "react-router-dom"
import { FilterMatchMode } from "primereact/api"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Sidebar } from "primereact/sidebar"
import { InputTextarea } from "primereact/inputtextarea"
import "jspdf-autotable"
import { ChevronDownIcon } from "primereact/icons/chevrondown"
import { ChevronRightIcon } from "primereact/icons/chevronright"
import { Dialog } from "primereact/dialog"
import axios from "axios"
import { getCompanies, createCompany, updateCompany, deleteCompany, getLookupsByName, getProjects, getWorkTypes, getEntityNotes, createEntityNote, updateEntityNote, deleteEntityNote, createEntityDocument, getEntityDocuments, updateEntityDocument, deleteEntityDocument } from "../../helpers/backend-helper"
import { getAuthToken, getAuthUser, getCookie } from "../../helpers/cookie-utils"
import { useForm } from "react-hook-form"
import { Calendar } from "primereact/calendar"
import moment from "moment"
import { Accordion, AccordionTab } from "primereact/accordion"
import { Badge } from "primereact/badge"
import { TreeTable } from "primereact/treetable"
import { Card } from "primereact/card"
import { Editor } from "primereact/editor"
import { CascadeSelect } from "primereact/cascadeselect"
import { MultiSelect } from "primereact/multiselect"
import { Checkbox } from "primereact/checkbox"
import { Chips } from "primereact/chips"
import { TreeSelect } from "primereact/treeselect"
import { Tooltip } from "primereact/tooltip"
import { ContextMenu } from "primereact/contextmenu"
import { Toast } from "primereact/toast"
import NotesCompanies from "../common-for-all/NotesCompanies"
import NotesCompanies1 from "../common-for-all/NotesCompaniesNames"
import LinkContact2Popup from "pms/common-for-all/LinkContact2Popup"
import LinkContactsPopup from "pms/common-for-all/LinkContactsPopup"
import LinkWorkTypePopup from "pms/common-for-all/LinkWorkTypePopup"
import LinkContactProject from "pms/common-for-all/LinkContactProject"
import MoreACcompanies from "./MoreActionitems"
import { FileUpload } from "primereact/fileupload"
import AddContact from "./AddContact"
import { useNavigate } from "react-router-dom"

import { useSelector } from "react-redux"
import { SET_API_STATUS_FALSE, SET_API_STATUS_TRUE } from "../../store/calendar/actionTypes"

const CompanyArchived = () => {
  const { first, rows } = useSelector(state => state.calendar.pagination)
  const apiStatus = useSelector(state => state.calendar.apiStatus)
  const [selectedCategory1, setSelectedCategory1] = useState(null)
  const fileUploadRef = useRef(null)
  const [selectedEmailOption, setSelectedEmailOption] = useState(null)
  const [selectedGroup1, setSelectedGroup1] = useState(null)
  const [privateUserValues, setPrivateUserValues] = useState(null)
  const [documentTypes, setDocumentTypes] = useState([]);
  const [displayDialog, setDisplayDialog] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [subject, setSubject] = useState('');
  const {
    register,
    handleSubmit,
    reset,
    trigger,
    clearErrors,
    formState: { errors },
    setValue,
    getValues,
  } = useForm()

  const selectedEmailTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-envelope mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const emailOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }

  const [selectedSmsOption, setSelectedSmsOption] = useState(null)
  const smsOptions = [
    { label: "Selected", icon: "pi pi-check-circle" },
    { label: "Searched", icon: "pi pi-search" },
    { label: "All", icon: "pi pi-inbox" },
  ]

  const selectedSmsTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-comment mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const smsOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }

  //schedule

  const [selectedScheduleOption, setSelectedScheduleOption] = useState(null)

  const scheduleOptions = [
    { label: "Interview", icon: "pi pi-calendar-plus" },
    { label: "Call", icon: "pi pi-phone" },
    { label: "Meeting", icon: "pi pi-users" },
    { label: "Task", icon: "pi pi-check-square" },
    { label: "Event", icon: "pi pi-calendar" },
    { label: "Other", icon: "pi pi-cog" },
  ]

  const selectedScheduleTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`} />
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-calendar mr-2" />{" "}
        {/* Default icon for placeholder */}
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const scheduleOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`} />
        <div>{option.label}</div>
      </div>
    )
  }

  // more

  const [selectedOption, setSelectedOption] = useState(null)


  const selectedOptionTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-cog mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const optionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }

  // action items

  const items = [
    {
      label: "Add",
      icon: "pi pi-pencil",
      command: () => {
        toast.current.show({
          severity: "info",
          summary: "Add",
          detail: "Data Added",
        })
      },
    },
    {
      label: "Update",
      icon: "pi pi-refresh",
      command: () => {
        toast.current.show({
          severity: "success",
          summary: "Update",
          detail: "Data Updated",
        })
      },
    },
    {
      label: "Delete",
      icon: "pi pi-trash",
      command: () => {
        toast.current.show({
          severity: "error",
          summary: "Delete",
          detail: "Data Deleted",
        })
      },
    },
  ]

  document.title = "PMS - Dashboard"

  const [customers, setCustomers] = useState([])

  const onSelectionChange = e => {
    setSelectedCustomers(e.value)
  }
  const onRowReorder = e => {
    setCustomers(e.value)
  }

  const onCellEditComplete = async (e) => {
    const { rowData, newValue, field } = e;
    if (rowData[field] !== newValue) {
      try {
        // Prepare update data
        const updateData = { ...rowData, [field]: newValue };
        console.log("Updating company:", rowData.id, "Field:", field, "New value:", newValue);
        
        // Call the API to update the company
        await updateCompany(rowData.id, updateData);
        
        // Update local state
        const updatedCustomers = customers.map(customer =>
          customer.id === rowData.id
            ? { ...customer, [field]: newValue }
            : customer
        );
        setCustomers(updatedCustomers);
        
        toast.current?.show({
          severity: "success",
          summary: "Updated",
          detail: `${field} updated successfully.`,
        });
        
      } catch (error) {
        console.error("Error updating company:", error);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to update company. Please try again.",
        });
      }
    }
  };

  // const header = renderHeader();
  const [visible, setVisible] = useState(false) // State to control the visibility of the modal

  const [company, setCompany] = useState(null)

  const companies = [
    { name: "Tech Corp", code: "TC" },
    { name: "BizCorp", code: "BC" },
    { name: "Creative Solutions", code: "CS" },
    { name: "Innovative Tech", code: "IT" },
  ]

  const [website, setWebsite] = useState("")

  const [visibleRight, setVisibleRight] = useState(false)
  const [apiCallStatus, setApiCallStatus] = useState(false)
  const [industry, setIndustry] = useState(null)
  const [companySize, setCompanySize] = useState(null)
  const [yearFounded, setYearFounded] = useState(null)
  // Generate a list of years from 1900 to the current year
  const currentYear = new Date().getFullYear()
  const years = Array.from({ length: currentYear - 1899 }, (_, index) => ({
    name: (1900 + index).toString(),
    code: (1900 + index).toString(),
  }))

  const [specialties, setSpecialties] = useState([])

  const [phoneNumber, setPhoneNumber] = useState("")
  const [workEmail, setWorkEmail] = useState("")

  // State to manage which form is being shown
  const [currentForm, setCurrentForm] = useState(1)

  // Handler for "Next" button click to go to next form
  const handleNext = () => {
    setCurrentForm(currentForm + 1)
  }

  // Handler for "Previous" button click to go to previous form
  const handlePrevious = () => {
    setCurrentForm(currentForm - 1)
  }

  const [description, setDescription] = useState("")

  const addCities = [
    { name: "Hyderabad", code: "HYD" },
    { name: "Chennai", code: "CHN" },
    { name: "Mumbai", code: "MUM" },
    { name: "Bangalore", code: "BLR" },
    { name: "Delhi", code: "DEL" },
  ]

  const addStates = [
    { name: "Andhra Pradesh", code: "AP" },
    { name: "Telangana", code: "TG" },
    { name: "Tamil Nadu", code: "TN" },
    { name: "Karnataka", code: "KA" },
    { name: "Kerala", code: "KL" },
  ]

  const addCountries = [
    { name: "India", code: "IN" },
    { name: "United States", code: "US" },
    { name: "Canada", code: "CA" },
    { name: "Germany", code: "DE" },
    { name: "Australia", code: "AU" },
  ]

  const labels = [
    { name: "Work from Office (WFO)", code: "WORK" },
    { name: "Work from Home (WFH)", code: "HOME" },
    { name: "Work from Remote (WFR)", code: "REMOTE" },
  ]

  const [selectedUserId, setSelectedUserId] = useState(null)
  const userIds = [
    { name: "User 1", code: "U1" },
    { name: "User 2", code: "U2" },
    { name: "User 3", code: "U3" },
    { name: "User 4", code: "U4" },
    { name: "User 5", code: "U5" },
  ]

  {
    /* Side bar end */
  }
  const [categoriesitem, setcategoriesitem] = useState([])
  const [groupitem, setgroupitem] = useState([])
  const [compamyitem, setcompamyitem] = useState([])
  const [industryOptions, setIndustryOptions] = useState([])
  const [companySizeOptions, setCompanySizeOptions] = useState([])
  const [year, setYear] = useState(null)

  // Dynamic arrays using useMemo to avoid initialization issues
  const industries = useMemo(() => {
    return industryOptions.length > 0 ? industryOptions.map(item => ({
      name: item.name || item.value,
      code: item.code || item.id,
      id: item.id
    })) : [
      { name: "Information Technology", code: "IT" },
      { name: "Healthcare", code: "HC" },
      { name: "Finance", code: "FN" },
      { name: "Manufacturing", code: "MN" },
      { name: "Retail", code: "RT" },
    ];
  }, [industryOptions]);

  // const companySizes = useMemo(() => {
  //   return companySizeOptions.length > 0 ? companySizeOptions.map(item => ({
  //     name: item.name || item.value,
  //     code: item.code || item.id,
  //     id: item.id
  //   })) : [
  //     { name: "1-10 employees", code: "1-10" },
  //     { name: "11-50 employees", code: "11-50" },
  //     { name: "51-200 employees", code: "51-200" },
  //     { name: "201-500 employees", code: "201-500" },
  //     { name: "501-1000 employees", code: "501-1000" },
  //     { name: "1001-5000 employees", code: "1001-5000" },
  //     { name: "5001+ employees", code: "5001+" },
  //   ];
  // }, [companySizeOptions]);

  // Private state variables
  const [privateDrop, setPrivateDrop] = useState(false)
  const [PrivetDropdown, setPrivetDropdown] = useState([])
  const [PrivetDropdownValues, setPrivetDropdownValues] = useState(null)
  // Token for API calls
  const token = getCookie('access_token');
  
  // Get private users for dropdown
  const getPrivateOptions = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/private-users/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        let results = response.data.data;
        const options = results.map((category) => ({
          name: category.name
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase()),
          code: category.id,
          email: category.email,
        }));
        setPrivetDropdownValues(options);
      }
    } catch (error) {

    }
  };

  const [address, setAddress] = useState("")
  const [selectedState, setSelectedState] = useState("")
  const [selectedCity, setSelectedCity] = useState("")
  const [selectedCountry, setSelectedCountry] = useState("")
  const [selectedLabel, setSelectedLabel] = useState(null)
  const [postalCode, setPostalCode] = useState("")
  const [street1, setStreet1] = useState("")
  const [street2, setStreet2] = useState("")

  const updateAddress = () => {
    // setAddress(`${street1}  ${street2} ${postalCode}`.trim());
  }
  useEffect(() => {
    // Build a normalized address string. Selected city/state/country may be objects
    const updatedAddressParts = [
      street1,
      street2,
      // If selected value is an object use its name, otherwise use the string
      (selectedCity && (selectedCity.name || selectedCity)) || null,
      (selectedState && (selectedState.name || selectedState)) || null,
      (selectedCountry && (selectedCountry.name || selectedCountry)) || null,
      postalCode,
      selectedLabel?.name,
    ].filter(Boolean)

    // Join with line breaks to show each part on a separate line
    setAddress(updatedAddressParts.join('\n'))
  }, [
    street1,
    street2,
    postalCode,
    selectedState,
    selectedCity,
    selectedCountry,
    selectedLabel,
  ])

  const getcategoriesitem = async () => {
    try {
      console.log("Fetching categories from API...");
      const response = await getLookupsByName("categories");
      console.log("Categories API response:", response);
      
      if (response && response.data) {
        setcategoriesitem(response.data);
      } else if (response && Array.isArray(response)) {
        setcategoriesitem(response);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      // Fallback to keep the current functionality working
    }
  };
  // New: fetch company categories from lookups table (company_categories)
  const [categoryOptionsState, setCategoryOptionsState] = useState([]);
  const [selectedEditdrop, setSelectedEditdrop] = useState(null)
  const [selecteddropoptions, setselecteddropoptions] = useState([])
  const [statusModalVisible, setStatusModalVisible] = useState(false)
  const [statusModalContext, setStatusModalContext] = useState('company_categories')
  const [statusForm, setStatusForm] = useState('')
  const [statusDescription, setStatusDescription] = useState('')
  const [editingStatus, setEditingStatus] = useState(false)
  const [lastSelectedCategoryId, setLastSelectedCategoryId] = useState(null)
  const [lastSelectedIndustryId, setLastSelectedIndustryId] = useState(null)

  const getCompanyCategoryOptions = async () => {
    try {
      console.log("Fetching company category options from API...");
      const response = await getLookupsByName("company_categories");
      console.log("Company categories API response:", response);

      let rawData = [];
      if (!response) {
        rawData = [];
      } else if (Array.isArray(response)) {
        rawData = response;
      } else if (response.data && Array.isArray(response.data)) {
        rawData = response.data;
      } else if (response.data && response.data.results && Array.isArray(response.data.results)) {
        rawData = response.data.results;
      } else if (response.results && Array.isArray(response.results)) {
        rawData = response.results;
      } else if (response.results && response.results.results && Array.isArray(response.results.results)) {
        rawData = response.results.results;
      } else if (response.results && response.results.data && Array.isArray(response.results.data)) {
        rawData = response.results.data;
      } else {
        rawData = [];
      }

      console.log('Raw company categories lookup data array:', rawData);
      const normalized = rawData.map(item => ({
        id: item.id ?? item.pk ?? item.code ?? null,
        name: item.value ?? item.name ?? item.label ?? String(item.id ?? item.code ?? ""),
        code: item.code ?? item.code,
        raw: item,
      }));

      console.log('Normalized company category options:', normalized);
      setCategoryOptionsState(normalized);
    } catch (error) {
      console.error("Error fetching company category options:", error);
    }
  };
  // New: fetch company groups from lookups table (company_group)
  const [groupOptionsState, setGroupOptionsState] = useState([]);
  const [lastSelectedGroupId, setLastSelectedGroupId] = useState(null)

  const getCompanyGroupOptions = async () => {
    try {
      console.log("Fetching company group options from API...");
      const response = await getLookupsByName("company_group");
      console.log("Company groups API response:", response);

      let rawData = [];
      if (!response) {
        rawData = [];
      } else if (Array.isArray(response)) {
        rawData = response;
      } else if (response.data && Array.isArray(response.data)) {
        rawData = response.data;
      } else if (response.data && response.data.results && Array.isArray(response.data.results)) {
        rawData = response.data.results;
      } else if (response.results && Array.isArray(response.results)) {
        rawData = response.results;
      } else if (response.results && response.results.results && Array.isArray(response.results.results)) {
        rawData = response.results.results;
      } else if (response.results && response.results.data && Array.isArray(response.results.data)) {
        rawData = response.results.data;
      } else {
        rawData = [];
      }

      console.log('Raw company groups lookup data array:', rawData);
      const normalized = rawData.map(item => ({
        id: item.id ?? item.pk ?? item.code ?? null,
        name: item.value ?? item.name ?? item.label ?? String(item.id ?? item.code ?? ""),
        code: item.code ?? item.code,
        raw: item,
      }));

      console.log('Normalized company group options:', normalized);
      setGroupOptionsState(normalized);
    } catch (error) {
      console.error("Error fetching company group options:", error);
    }
  };
  const getgroupsitem = async () => {
    try {
      console.log("Fetching groups from API...");
      const response = await getLookupsByName("groups");
      console.log("Groups API response:", response);
      
      if (response && response.data) {
        setgroupitem(response.data);
      } else if (response && Array.isArray(response)) {
        setgroupitem(response);
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
      // Fallback to keep the current functionality working
    }
  };

  const getIndustryOptions = async () => {
    try {
      console.log("Fetching industry options from API...");
      // Use lookup name 'company_industry' to fetch industry values from lookups table
      const response = await getLookupsByName("company_industry");
      console.log("Industry API response:", response);

      // Normalize response to an array of { id, name, code, raw }
      let rawData = [];
      if (!response) {
        rawData = [];
      } else if (Array.isArray(response)) {
        rawData = response;
      } else if (response.data && Array.isArray(response.data)) {
        rawData = response.data;
      } else if (response.data && response.data.results && Array.isArray(response.data.results)) {
        rawData = response.data.results;
      } else if (response.results && Array.isArray(response.results)) {
        rawData = response.results;
      } else if (response.results && response.results.results && Array.isArray(response.results.results)) {
        // Some endpoints wrap results deeper: results: { results: [...] }
        rawData = response.results.results;
      } else if (response.results && response.results.data && Array.isArray(response.results.data)) {
        // Another possible nesting: results: { data: [...] }
        rawData = response.results.data;
      } else {
        rawData = [];
      }

  console.log('Raw industry lookup data array:', rawData);
  const normalized = rawData.map(item => ({
        id: item.id ?? item.pk ?? item.code ?? null,
        name: item.value ?? item.name ?? item.label ?? String(item.id ?? item.code ?? ""),
        code: item.code ?? item.code,
        raw: item,
      }));

      console.log("Normalized industry options:", normalized);
      setIndustryOptions(normalized);
    } catch (error) {
      console.error("Error fetching industry options:", error);
      // Fallback to keep the current functionality working
    }
  };

  // Watch for sentinel selection on category dropdown
  useEffect(() => {
    try {
      if (!selectedCategory1) return;
      if (selectedCategory1.id === 'add' || selectedCategory1 === 'add') {
        setEditingStatus(false)
        setStatusForm('')
        setStatusDescription('')
        setStatusModalContext('company_categories')
        setStatusModalVisible(true)
        setSelectedCategory1(null)
      } else if (selectedCategory1.id === 'edit' || selectedCategory1 === 'edit') {
        // prepare to edit: populate the modal input from the last selected category
        setEditingStatus(true)
        setStatusModalContext('company_categories')
        
        try {
          const pool = categoryOptionsState.length ? categoryOptionsState : categoryOptions
          const match = pool.find(o => String(o.id) === String(lastSelectedCategoryId))
          if (match) setStatusForm(match.name || match.value || '')
            if (match) setStatusDescription((match.raw && (match.raw.description || match.raw.desc)) || match.description || '')
        } catch (err) { console.error('prefill category failed', err) }
        setStatusModalVisible(true)
      } else {
        // when a real category is selected, store its id for edit operations
        const idToSet = selectedCategory1 && (selectedCategory1.id ?? selectedCategory1);
        setLastSelectedCategoryId(idToSet)
        setSelectedEditdrop(idToSet)
      }
    } catch (err) {
      console.error('Category selection watcher error', err)
    }
  }, [selectedCategory1])

  // map modal context to edit-dropdown options
  useEffect(() => {
    if (statusModalContext === 'company_categories') setselecteddropoptions(categoryOptionsState.length ? categoryOptionsState : categoryOptions)
    else if (statusModalContext === 'company_industry') setselecteddropoptions(industryOptions.length ? industryOptions : industries)
    else if (statusModalContext === 'company_group') setselecteddropoptions(groupOptionsState.length ? groupOptionsState : [])
    else setselecteddropoptions([])
  }, [statusModalContext, categoryOptionsState, industryOptions, groupOptionsState])

  // Watch for sentinel selection on industry dropdown
  useEffect(() => {
    try {
      if (!industry) return;
      if (industry.id === 'add' || industry === 'add') {
        setEditingStatus(false)
        setStatusForm('')
        setStatusDescription('')
        setStatusModalContext('company_industry')
        setStatusModalVisible(true)
        setIndustry(null)
      } else if (industry.id === 'edit' || industry === 'edit') {
          setEditingStatus(true)
          setStatusModalContext('company_industry')
          try {
            const pool = industryOptions.length ? industryOptions : industries
            const match = pool.find(o => String(o.id) === String(lastSelectedIndustryId))
            if (match) setStatusForm(match.name || match.value || '')
            if (match) setStatusDescription((match.raw && (match.raw.description || match.raw.desc)) || match.description || '')
          } catch (err) { console.error('prefill industry failed', err) }
          setStatusModalVisible(true)
      } else {
        const idToSet = industry && (industry.id ?? industry);
        setLastSelectedIndustryId(idToSet)
        setSelectedEditdrop(idToSet)
      }
    } catch (err) {
      console.error('Industry selection watcher error', err)
    }
  }, [industry])

  // Watch for sentinel selection on group dropdown
  useEffect(() => {
    try {
      if (!selectedGroup1) return;
      const val = selectedGroup1 && (selectedGroup1.id ?? selectedGroup1)
      if (val === 'add' || (selectedGroup1 && selectedGroup1.id === 'add')) {
        setEditingStatus(false)
        setStatusForm('')
        setStatusDescription('')
        setStatusModalContext('company_group')
        setStatusModalVisible(true)
        setSelectedGroup1(null)
      } else if (val === 'edit' || (selectedGroup1 && selectedGroup1.id === 'edit')) {
        setEditingStatus(true)
        setStatusModalContext('company_group')
        try {
          const pool = groupOptionsState.length ? groupOptionsState : []
          const match = pool.find(o => String(o.id) === String(lastSelectedGroupId))
          if (match) setStatusForm(match.name || match.value || '')
          if (match) setStatusDescription((match.raw && (match.raw.description || match.raw.desc)) || match.description || '')
        } catch (err) { console.error('prefill group failed', err) }
        setStatusModalVisible(true)
      } else {
        const idToSet = selectedGroup1 && (selectedGroup1.id ?? selectedGroup1)
        setLastSelectedGroupId(idToSet)
        setSelectedEditdrop(idToSet)
      }
    } catch (err) {
      console.error('Group selection watcher error', err)
    }
  }, [selectedGroup1, lastSelectedGroupId, groupOptionsState])

  // Generic save handler for lookups used by Category/Industry
  const handleLookupSave = async (lookupName, lastSelectedIdForContext) => {
    try {
      if (statusForm?.trim() === "") {
         toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Value cannot be empty' })
        return
      }
  const body = { name: lookupName, value: statusForm, description: statusDescription || statusForm, type: 'company' }
      // Resolve id whether caller passed object or primitive
      let patchId = null
      if (lastSelectedIdForContext) {
        patchId = lastSelectedIdForContext?.id ?? lastSelectedIdForContext
      }
      // If patchId is a string like 'medium' coming from hardcoded fallbacks, try to resolve
      // to the actual numeric id from our normalized option pools so PATCH uses the correct id.
      try {
        if (patchId && typeof patchId === 'string' && isNaN(Number(patchId))) {
          // pick the correct pool based on lookup name
          let pool = []
          if (lookupName === 'company_categories') pool = categoryOptionsState.length ? categoryOptionsState : (categoryOptions || [])
          if (lookupName === 'company_industry') pool = industryOptions.length ? industryOptions : (industries || [])
          const found = pool.find(o => String(o.id) === String(patchId) || String(o.value) === String(patchId) || String(o.name) === String(patchId))
          if (found) patchId = found.id ?? found.value ?? patchId
        }
      } catch (resolveErr) {
        console.warn('Could not resolve string patchId to numeric id', resolveErr)
      }
      const token = getCookie('access_token') || getCookie('authToken')
      if (editingStatus && patchId) {
        await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${patchId}/`, body, { headers: { Authorization: `Bearer ${token}` } })
      } else {
        await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, body, { headers: { Authorization: `Bearer ${token}` } })
      }
      setStatusModalVisible(false)
      setEditingStatus(false)
      setStatusForm('')
  setStatusDescription('')
      // refresh relevant lists
      if (lookupName === 'company_categories') await getCompanyCategoryOptions()
      if (lookupName === 'company_industry') await getIndustryOptions()
      if (lookupName === 'company_group') await getCompanyGroupOptions()
    } catch (err) {
      console.error('Failed saving lookup', err)
    }
  }

  const getCompanySizeOptions = async () => {
    try {
      console.log("Fetching company size options from API...");
      const response = await getLookupsByName("company_size");
      console.log("Company size API response:", response);

      let rawData = [];
      if (!response) {
        rawData = [];
      } else if (Array.isArray(response)) {
        rawData = response;
      } else if (response.data && Array.isArray(response.data)) {
        rawData = response.data;
      } else if (response.data && response.data.results && Array.isArray(response.data.results)) {
        rawData = response.data.results;
      } else if (response.results && Array.isArray(response.results)) {
        rawData = response.results;
      } else if (response.results && response.results.results && Array.isArray(response.results.results)) {
        rawData = response.results.results;
      } else if (response.results && response.results.data && Array.isArray(response.results.data)) {
        rawData = response.results.data;
      } else {
        rawData = [];
      }

      console.log('Raw company size lookup data array:', rawData);
      const normalized = rawData.map(item => ({
        id: item.id ?? item.pk ?? item.code ?? null,
        name: item.value ?? item.name ?? item.label ?? String(item.id ?? item.code ?? ""),
        code: item.code ?? item.code,
        raw: item,
      }));
      console.log('Normalized company size options:', normalized);
      setCompanySizeOptions(normalized);
    } catch (error) {
      console.error("Error fetching company size options:", error);
      // Fallback to keep the current functionality working
    }
  };
  const getCompanydata = async () => {
    setLoading(true);
    try {
      const response = await getCompanies({is_archived: true});
      let companiesData = [];
      
      // Optimized response handling
      if (response?.data?.results) {
        companiesData = response.data.results;
      } else if (response?.data && Array.isArray(response.data)) {
        companiesData = response.data;
      } else if (response?.results) {
        companiesData = response.results;
      } else if (Array.isArray(response)) {
        companiesData = response;
      }
      
      console.log(`Processing ${companiesData.length} companies...`);
      console.time("CompanyData-Processing");
      
      // Create lookup maps for O(1) performance instead of O(n) find operations
      const industryLookup = new Map();
      const companySizeLookup = new Map();
      const categoryLookup = new Map();
      const groupLookup = new Map();
      
      // Build lookup maps once
      (industryOptions || []).forEach(item => {
        industryLookup.set(item.id, item.name);
        industryLookup.set(String(item.id), item.name);
        if (item.code) industryLookup.set(item.code, item.name);
      });
      
      (industries || []).forEach(item => {
        industryLookup.set(item.id, item.name);
        industryLookup.set(String(item.id), item.name);
        if (item.code) industryLookup.set(item.code, item.name);
      });
      
      (companySizeOptions || []).forEach(item => {
        companySizeLookup.set(item.id, item.name);
        companySizeLookup.set(String(item.id), item.name);
        if (item.code) companySizeLookup.set(item.code, item.name);
      });
      
      (categoryOptionsState || []).forEach(item => {
        categoryLookup.set(item.id, item.name);
        categoryLookup.set(item.value, item.name);
      });
      
      (categoryOptions || []).forEach(item => {
        categoryLookup.set(item.id, item.name || item.label);
        categoryLookup.set(item.value, item.name || item.label);
      });
      
      (groupOptionsState || []).forEach(item => {
        groupLookup.set(item.id, item.name);
        groupLookup.set(item.value, item.name);
      });
      
      (groupitem || []).forEach(item => {
        groupLookup.set(item.id, item.value || item.name || item.label);
        if (item.value) groupLookup.set(item.value, item.value || item.name || item.label);
      });
      
      (groupOptions || []).forEach(item => {
        groupLookup.set(item.id, item.name || item.label);
        if (item.value) groupLookup.set(item.value, item.name || item.label);
      });

      // Optimized date formatter
      const fmtDate = (d) => {
        if (!d) return '';
        try {
          const dt = new Date(d);
          return !isNaN(dt.getTime()) ? dt.toLocaleString() : String(d);
        } catch (e) {
          return String(d);
        }
      };

      // Fast lookup helpers
      const getIndustryName = (industry) => {
        if (!industry) return '';
        if (typeof industry === 'object') return industry.value || industry.name || industry.label || '';
        return industryLookup.get(industry) || industryLookup.get(Number(industry)) || String(industry);
      };

      const getCompanySizeName = (size) => {
        if (!size) return '';
        if (typeof size === 'object') return size.value || size.name || '';
        return companySizeLookup.get(size) || companySizeLookup.get(Number(size)) || String(size);
      };

      const getCategoryNames = (categories) => {
        if (!categories) return '';
        if (!Array.isArray(categories)) return String(categories);
        return categories.map(cid => 
          categoryLookup.get(cid) || categoryLookup.get(Number(cid)) || String(cid)
        ).join(', ');
      };

      const getGroupNames = (groups) => {
        if (!groups) return '';
        if (!Array.isArray(groups)) return String(groups);
        return groups.map(gid => 
          groupLookup.get(gid) || groupLookup.get(Number(gid)) || String(gid)
        ).join(', ');
      };

      const getCreatedByName = (createdBy) => {
        if (!createdBy) return '';
        if (typeof createdBy === 'object') return createdBy.name || createdBy.username || '';
        return String(createdBy);
      };

      // Optimized mapping with pre-compiled functions
      const mappedData = companiesData.map(company => ({
        id: company.id,
        company: company.name || '',
        website: company.website || '',
        industry: getIndustryName(company.industry),
        companySize: getCompanySizeName(company.company_size),
        yearFounded: company.year_founded || company.yearFounded || '',
        email: company.email || '',
        mobilePhone: company.phone || '',
        address: company.address || '',
        notes: Array.isArray(company.notes) 
          ? company.notes.map(note => note.subject || note.content || note).join(', ')
          : (company.notes || ''),
        category: getCategoryNames(company.categories),
        overview: company.overview || '',
        description: company.description || '',
        group: getGroupNames(company.groups),
        createdBy: getCreatedByName(company.created_by),
        lastActivityDate: fmtDate(company.last_activity_date || company.lastActivityDate),
        createDate: fmtDate(company.created_at || company.createDate),
        editDate: fmtDate(company.updated_at || company.updatedAt),
        // Keep original data
        ...company
      }));
      
      console.timeEnd("CompanyData-Processing");
      console.log(`Processed ${mappedData.length} companies successfully`);
      
      // Batch state updates to prevent multiple re-renders
      setcompamyitem(mappedData);
      setCustomers(mappedData);
      setCompanyData(mappedData);
      
    } catch (error) {
      console.error("Error fetching companies:", error);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to load companies. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  }

  // Function to handle company creation
  const handleCreateCompany = async () => {
    // Basic validation
    if (!company1?.trim()) {
      toast.current?.show({
        severity: "error",
        summary: "Validation Error",
        detail: "Company name is required.",
      });
      return;
    }

    if (!email1?.trim()) {
      toast.current?.show({
        severity: "error",
        summary: "Validation Error",
        detail: "Email is required.",
      });
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email1)) {
      toast.current?.show({
        severity: "error",
        summary: "Validation Error",
        detail: "Please enter a valid email address.",
      });
      return;
    }

    setLoading(true);
    try {
      console.log("Creating new company...");
      
      // Get current user for tenant info
      const currentUser = getAuthUser();
      console.log("Current user from cookies:", currentUser);
      console.log("User keys:", currentUser ? Object.keys(currentUser) : "No user");
      console.log("Raw cookie value:", getCookie('authUser'));
      
      if (!currentUser) {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "No authentication information found. Please log in again.",
        });
        return;
      }
      
      // Try different possible tenant field names
      const tenantId = currentUser.tenant_id || currentUser.tenant || currentUser.id || currentUser.user_id;
      console.log("Tenant ID found:", tenantId);
      
      if (!tenantId) {
        console.log("Available user fields:", Object.keys(currentUser));
        toast.current?.show({
          severity: "error",
          summary: "Error", 
          detail: `Unable to determine tenant information. Available fields: ${Object.keys(currentUser).join(', ')}`,
        });
        return;
      }
      
      // Prepare company data from form state
      const companyData = {
        tenant: tenantId,
        name: company1.trim(),
        // company_code: `COMP-${Date.now()}`, // Generate a unique company code
        website: website1?.trim() || '',
        email: email1.trim(),
        phone: phno1?.trim() || '',
        // Build a safe address string. selectedCity/state/country may be objects or strings.
        address: address || [
          street1 || '',
          street2 || '',
          (selectedCity && (selectedCity.name || selectedCity)) || '',
          (selectedState && (selectedState.name || selectedState)) || '',
          (selectedCountry && (selectedCountry.name || selectedCountry)) || '',
          postalCode || ''
        ].filter(Boolean).join(', ').replace(/,\s*,/g, ',').replace(/^,+|,+$/g, '').trim(),
        // Robust year_founded: accept Date, number, or string from form
        year_founded: (() => {
          try {
            if (year) {
              if (year instanceof Date) return year.getFullYear();
              if (typeof year === 'number') return year;
              const parsed = Number(year);
              if (!isNaN(parsed)) return parsed;
              const d = new Date(year);
              if (!isNaN(d.getTime())) return d.getFullYear();
            }
            // fallback to yearfounded1 (string) or yearFounded state
            if (yearfounded1) {
              const p = Number(yearfounded1);
              if (!isNaN(p)) return p;
            }
            if (yearFounded) {
              if (yearFounded instanceof Date) return yearFounded.getFullYear();
              const p2 = Number(yearFounded);
              if (!isNaN(p2)) return p2;
            }
          } catch (err) {
            console.warn('Unable to determine year_founded from form state', err);
          }
          return null;
        })(),
        specialties: specialties1?.trim() || '',
        industry: industry?.id || null, // Send the ID if it's a dropdown selection
        company_size: companySize?.id || null, // Send the ID if it's a dropdown selection
        overview: overview1?.trim() || '',
        description: overview1?.trim() || '', // Using overview as description
        // Only include M2M fields if they have valid values
        ...(selectedCategory1 && selectedCategory1.id && {
          categories: [selectedCategory1.id]
        }),
        ...(selectedGroup1 && selectedGroup1.id && {
          groups: [selectedGroup1.id]
        }),
        // Only include private users if privateDrop is checked and there are valid users
        ...(privateDrop && PrivetDropdown && PrivetDropdown.length > 0 && {
          private_users: PrivetDropdown.filter(user => user && user.code).map(user => user.code)
        })
      };

      console.log("Company data to be sent:", companyData);
      console.log("Uploaded files from state:", uploadedFiles);
      console.log("Uploaded files from ref:", uploadedFilesRef.current);
      console.log("Uploaded files length:", uploadedFilesRef.current ? uploadedFilesRef.current.length : 0);

      // First, create the company without documents
      console.log("Creating company without documents...");
      const response = await createCompany(companyData);
      console.log("Create company response:", response);
      console.log("Response keys:", response ? Object.keys(response) : "No response");
      
      // Try different possible ID field names
      const createdCompanyId = response.id || response.pk || response.company_id || response.data?.id || response.data?.pk;
      
      if (!createdCompanyId) {
        console.error("Available response fields:", response ? Object.keys(response) : "No response");
        throw new Error("Company created but no ID returned from server. Response: " + JSON.stringify(response));
      }
      const filesToUpload = uploadedFilesRef.current;
      
      // Debug each file before upload
      if (filesToUpload && filesToUpload?.length > 0) {
        console.log("=== PRE-UPLOAD FILE VALIDATION ===");
        filesToUpload.forEach((file, index) => {
          console.log(`Pre-upload File ${index}:`, file);
          console.log(`Pre-upload File ${index} instanceof File:`, file instanceof File);
          console.log(`Pre-upload File ${index} name:`, file.name);
          console.log(`Pre-upload File ${index} size:`, file.size);
          console.log(`Pre-upload File ${index} type:`, file.type);
          console.log(`Pre-upload File ${index} constructor:`, file.constructor.name);
          console.log("---");
        });
        console.log("=== END PRE-UPLOAD VALIDATION ===");
      }

      if (filesToUpload && filesToUpload?.length > 0) {
        console.log("Uploading documents to company...");
        
        try {
          const documentUploadPromises = filesToUpload.map(async (file, index) => {
            console.log(`Uploading document ${index + 1}:`, file.name, file);
            console.log("Original file object:", file);
            console.log("File properties:", Object.keys(file));
            console.log("File instanceof File:", file instanceof File);
            console.log("File size:", file.size);
            console.log("File type:", file.type);
            
            // Validate file object before proceeding
            if (!file || !(file instanceof File)) {
              console.error(`Invalid file object at index ${index}:`, file);
              console.error(`File type: ${typeof file}, constructor: ${file?.constructor?.name}`);
              console.error(`File properties:`, Object.keys(file || {}));
              throw new Error(`Invalid file object at index ${index}: ${file?.name || 'Unknown'}`);
            }
            
            if (!file.name || file.size === 0) {
              console.error(`File validation failed for ${file.name}:`, { name: file.name, size: file.size });
              throw new Error(`File validation failed: ${file.name || 'Unknown'}`);
            }
            
            console.log(`File ${index} passed initial validation`);
            
            try {
              // Test FormData creation before using the helper
              console.log(`Testing FormData creation for file ${index}...`);
              const testFormData = new FormData();
              testFormData.append('test', file, file.name);
              const testRetrieved = testFormData.get('test');
              
              if (!(testRetrieved instanceof File)) {
                console.error(`FormData test failed for file ${index}:`, testRetrieved);
                throw new Error(`FormData test failed for file: ${file.name}`);
              }
              console.log(`FormData test passed for file ${index}`);
              
              // Use the validated FormData creation helper
              const documentFormData = createValidatedFormData(
                file, 
                `${file.name} - Document uploaded for ${companyData.name}`
              );
              
              console.log(`Created FormData for file ${index}, uploading...`);
              
              // Upload the document
              return await createEntityDocument('companies', createdCompanyId, documentFormData);
            } catch (error) {
              console.error(`Error processing file ${file.name}:`, error);
            }
          });
          
          const documentResults = await Promise.all(documentUploadPromises);
          console.log("All documents uploaded successfully:", documentResults);
          
          toast.current?.show({
            severity: "success",
            summary: "Success",
            detail: `Company created successfully with ${filesToUpload.length} document(s)!`,
          });
          
        } catch (documentError) {
          console.error("Error uploading documents:", documentError);
          // Company was created successfully, but document upload failed
          toast.current?.show({
            severity: "warn",
            summary: "Partial Success",
            detail: "Company created successfully, but some documents failed to upload. You can add them later.",
          });
        }
      } else {
        // No files to upload
        console.log("No documents to upload");
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Company created successfully!",
        });
      }

      // Reset form data
      resetCompanyForm();
      // Close sidebar
      setVisibleRight(false);
      setApiCallStatus(true)
      setTimeout(() => setApiCallStatus(false), 2000)
      // Refresh the company list
      await getCompanydata();
    } catch (error) {
      console.error("Error creating company:", error);
      let errorMessage = error?.response?.data?.message;
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: errorMessage,
        life: 3000
      });
    } finally {
      setLoading(false);
    }
  };

  // Function to reset company form
  const resetCompanyForm = () => {
    setCompany1("");
    setWebsite1("");
    setEmail1("");
    setPhno1("");
    setAddress("");
    setStreet1("");
    setStreet2("");
    setSelectedCity(null);
    setSelectedState(null);
    setSelectedCountry(null);
    setPostalCode("");
    setYear(null);
    setSpecialties1("");
    setIndustry(null);
    setCompanySize(null);
    setOverview1("");
    setSelectedCategory1(null);
    setSelectedGroup1(null);
    setPrivateDrop(false);
    setPrivetDropdown([]);
    setUploadedFiles([]); // Clear uploaded files from state
    uploadedFilesRef.current = []; // Clear uploaded files from ref
  };

  // Function to populate form fields when viewing a company
  const populateViewForm = (company) => {
    if (!company) return;
    
    console.log("Populating view form with company data:", company);
    console.log("Company fields available:", Object.keys(company));
    
    // Set the current viewed company for projects fetching
    setCurrentViewedCompany(company);
    
    // Fetch projects for this company
    const companyId = company.id || company.pk || company.company_id;
    if (companyId) {
      fetchCompanyProjects(companyId);
      fetchCompanyWorkTypes(companyId);
      fetchCompanyNotes(companyId);
      // FETCH REAL DOCUMENTS FROM DATABASE
      fetchCompanyDocuments(companyId);
    } else {
      console.warn("No valid company ID found for fetching projects, work types, notes, and documents:", company);
      setProjectData([]); // Clear projects if no valid ID
      setCompanyProjects([]); // Clear work types if no valid ID
      setCandidateNotes([]); // Clear notes if no valid ID
      // setDocuments([]); // Clear documents if no valid ID
    }
    
    // Basic company information (for create form)
    setCompany1(company.name || company.company || "");
    setWebsite1(company.website || "");
    setEmail1(company.email || "");
    setPhno1(company.phone || company.mobilePhone || "");
    
    // Handle address - could be object or string
    // Normalize address: API may return string, array of parts, or object
    let addressValue = "";
    if (!company.address) {
      addressValue = "";
    } else if (typeof company.address === 'string') {
      addressValue = company.address;
    } else if (Array.isArray(company.address)) {
      // Map array items to sensible string values
      addressValue = company.address.map(item => {
        if (!item) return '';
        if (typeof item === 'string' || typeof item === 'number') return String(item);
        if (typeof item === 'object') return item.name || item.label || item.value || item.city || item.state || '';
        return '';
      }).filter(Boolean).join(', ');
    } else if (typeof company.address === 'object') {
      // If address is an object, try common fields or stringify selected parts
      addressValue = company.address.formatted || company.address.display || company.address.address || '';
      if (!addressValue) {
        // Fallback: join object values that are primitive
        addressValue = Object.values(company.address).filter(v => (typeof v === 'string' || typeof v === 'number')).join(', ');
      }
    }

    setAddress(addressValue);
    console.log("Address set to:", addressValue);
    
    setSpecialties1(company.specialties || "");
    
    // Handle overview/description - try both field names
    const overviewValue = company.overview || company.description || "";
    setOverview1(overviewValue);
    console.log("Overview set to:", overviewValue);
    
    // View form specific fields
    setYearfounded1(String(company.year_founded || company.yearFounded || ""));
    setIndustry1(String(company.industry || ""));
    setCompanysize1(String(company.company_size || company.companySize || ""));
    
    // Handle category - could be string or object
    const categoryValue = typeof company.category === 'string' ? company.category : 
                         (company.categories || "");
    setCategoryValue(categoryValue);
    console.log("Category value set to:", categoryValue);
    
    // Handle groups - could be string or object  
    const groupsValue = typeof company.groups === 'string' ? company.groups : 
                       (Array.isArray(company.groups) ? company.groups.join(', ') : "");
    setGroupValue(groupsValue);
   const privateUserIds = company.private_users || [];

// Get names from PrivetDropdownValues
const selectedPrivateUserNames = Array.isArray(privateUserIds)
  ? privateUserIds
      .map(id => PrivetDropdownValues.find(user => user.code === id)?.name)
      .filter(Boolean) // remove undefined if ID not found
  : [];

// Set the names state or use it directly
setPrivateUserValues(selectedPrivateUserNames.join(', '));
    console.log("Groups value set to:", groupsValue);
    
    setUserid1(String(company.created_by || company.user_id || ""));
    
    // Year founded for Calendar component
    if (company.year_founded || company.yearFounded) {
      const yearValue = company.year_founded || company.yearFounded;
      setYear(new Date(yearValue, 0, 1)); // Create Date object for Calendar component
    } else {
      setYear(null);
    }
    
    // Industry - find matching option
    if (company.industry && industryOptions.length > 0) {
      const industryMatch = industryOptions.find(option => 
        option.value === company.industry || option.id === company.industry
      );
      setIndustry(industryMatch || null);
    }
    
    // Company Size - find matching option
    if (company.company_size && companySizeOptions.length > 0) {
      const sizeMatch = companySizeOptions.find(option => 
        option.value === company.company_size || option.id === company.company_size
      );
      setCompanySize(sizeMatch || null);
    }
    
    // Categories - find matching option (prefer lookup-driven normalized options)
    if (company.categories) {
      // Try the lookup-driven normalized options first
      let categoryMatch = null;
      if (categoryOptionsState && categoryOptionsState.length > 0) {
        categoryMatch = categoryOptionsState.find(opt => opt.id === company.categories || opt.value === company.categories || opt.name === company.categories || opt.raw?.value === company.categories);
      }
      // Fallback to older categoriesitem mapping
      if (!categoryMatch && categoryOptions && categoryOptions.length > 0) {
        categoryMatch = categoryOptions.find(opt => opt.id === company.categories || opt.value === company.categories || opt.name === company.categories || opt.raw?.value === company.categories || opt.label === company.categories);
      }
      setSelectedCategory1(categoryMatch || null);
    }
    
    // Groups - find matching option (prefer lookup-driven normalized options)
    if (company.groups) {
      let groupMatch = null;
      if (groupOptionsState && groupOptionsState.length > 0) {
        groupMatch = groupOptionsState.find(opt => opt.id === company.groups || opt.value === company.groups || opt.name === company.groups || opt.raw?.value === company.groups);
      }
      if (!groupMatch && groupOptions && groupOptions.length > 0) {
        groupMatch = groupOptions.find(opt => opt.id === company.groups || opt.value === company.groups || opt.name === company.groups || opt.raw?.value === company.groups || opt.label === company.groups);
      }
      setSelectedGroup1(groupMatch || null);
    }
    
    // Parse address if it's a string
    if (company.address && typeof company.address === 'string') {
      const addressParts = company.address.split(', ');
      if (addressParts.length >= 2) {
        setStreet1(addressParts[0] || "");
        setStreet2(addressParts[1] || "");
        if (addressParts.length > 2) {
          setPostalCode(addressParts[addressParts.length - 1] || "");
        }
      }
    }
  };

  const onSubmit = async data => {
    let address = {
      street: street1,
      city: street2,
      state: selectedState,
      zip: postalCode,
    }
    const formattedtoDate = moment(year).format("YYYY")
    const req = {
      project_title: data.description,
      company_name: data.comapany,
      email: data.personal_email,
      phone_number: data.Phone,
      specialties: data.Specialties,
      description: data.Overview,
      category: Number(data.Categories),
      group: Number(data.Group),
      founded_year: formattedtoDate,
      address: address,
    }
    try {
      console.log("Creating company with data:", req);
      const response = await createCompany(req);
      console.log("Company created successfully:", response);
      
      toast.current?.show({
        severity: "success",
        summary: "Success",
        detail: "Company created successfully!",
      });
      
      await getCompanydata(); // Reload the data
      setVisibleRight(false);
      reset(); // Reset the form
    } catch (error) {
      console.error("Error creating company:", error);
      
    }
  }

  useEffect(() => {
    (async () => {
      console.log("CompaniesAllActive component mounted - starting sequential data fetch");
      try {
        console.log("Calling getcategoriesitem...");
        await getcategoriesitem();
        console.log("Calling getgroupsitem...");
        await getgroupsitem();
        console.log("Calling getIndustryOptions...");
        await getIndustryOptions();
        console.log("Calling getCompanyCategoryOptions...");
        await getCompanyCategoryOptions();
        console.log("Calling getCompanyGroupOptions...");
        await getCompanyGroupOptions();
        console.log("Calling getCompanySizeOptions...");
        await getCompanySizeOptions();
        console.log("Calling getPrivateOptions...");
        await getPrivateOptions();
        console.log("Calling getCompanydata...");
        await getCompanydata();
      } catch (err) {
        console.error('Error during initial data fetch sequence:', err);
        // still attempt to load companies even if lookups partially fail
        try { await getCompanydata(); } catch (e) { console.error('Failed to fetch companies after lookups error', e); }
      }
    })();
  }, [])

  // companies datatable

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    company: { value: null, matchMode: FilterMatchMode.CONTAINS },
    website: { value: null, matchMode: FilterMatchMode.CONTAINS },
    industry: { value: null, matchMode: FilterMatchMode.CONTAINS },
    companySize: { value: null, matchMode: FilterMatchMode.CONTAINS },
    yearFounded: { value: null, matchMode: FilterMatchMode.CONTAINS },
    overview: { value: null, matchMode: FilterMatchMode.CONTAINS },
    email: { value: null, matchMode: FilterMatchMode.CONTAINS },
    mobilePhone: { value: null, matchMode: FilterMatchMode.CONTAINS },
    address: { value: null, matchMode: FilterMatchMode.CONTAINS },
    notes: { value: null, matchMode: FilterMatchMode.CONTAINS },
    category: { value: null, matchMode: FilterMatchMode.CONTAINS },
    group: { value: null, matchMode: FilterMatchMode.CONTAINS },
    userIds: { value: null, matchMode: FilterMatchMode.CONTAINS },
    createdBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
    lastActivityDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    createDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    editDate: { value: null, matchMode: FilterMatchMode.CONTAINS },

    if(dtImport) {
      dtImport.reset()
    },
  })

  const [companyData, setCompanyData] = useState([])

  const [selectedCompanyData, setSelectedCompanyData] = useState([])
  const [loading, setLoading] = useState(false)
  const [pageState, setPageState] = useState({ rows: 10, first: 0 })

  const onPage = event => {
    setPageState({ rows: event.rows, first: event.first })
  }

  const dt = useRef(null)
  const subjectTemplate = rowData => {
    // Handle different types of notes data
    let notesText = '';
    if (typeof rowData.notes === 'string') {
      notesText = rowData.notes;
    } else if (Array.isArray(rowData.notes) && rowData.notes.length > 0) {
      notesText = rowData.notes.map(note => 
        typeof note === 'string' ? note : (note?.subject || note?.content || '')
      ).join(', ');
    } else if (rowData.notes && typeof rowData.notes === 'object') {
      notesText = rowData.notes.subject || rowData.notes.content || '';
    } else {
      notesText = rowData.notes || '';
    }
    
    if (!notesText || notesText.length === 0) {
      return <span>-</span>;
    }
    
    const words = notesText.split(" ").slice(0, 2).join(" ") + (notesText.split(" ").length > 2 ? "..." : ""); // Show only first 2 words
    return (
      <span data-pr-tooltip={notesText} data-pr-position="top">
        {words}
      </span>
    )
  }
  // context menu starts
  const toast = useRef(null) // Reference for Toast notifications
  const navigate = useNavigate()
  const cm = useRef(null) // Reference for ContextMenu
  const [selectedCompany, setSelectedCompany] = useState(null) // State to track the right-clicked company
  // Context menu options
  const menuModel = [
    {
      label: "View",
      icon: "pi pi-fw pi-eye",
      command: () => {
        populateViewForm(selectedCompany);
        setVisibleViewRight(true);
      },
    },
    {
      label: "Edit",
      icon: "pi pi-fw pi-pencil",
      command: () => {
        console.log("Edit clicked - selectedCompany:", selectedCompany);
        navigate("/companies-editform", { state: { companyData: selectedCompany } });
      },
    },
    { label: "Archive", icon: "pi pi-check-circle" ,command: () => handleArchiveCompany(selectedCompany),},
    {
      label: "Delete",
      icon: "pi pi-fw pi-trash",
      command: () => handleDeleteCompany(selectedCompany),
    },
    {
      label: "Schedule",
      icon: "pi pi-calendar-clock",
      items: [
        {
          label: "Interview",
          icon: "pi pi-calendar-plus",
        },
        { label: "Call", icon: "pi pi-phone" },
        { label: "Meeting", icon: "pi pi-users" },
        { label: "Task", icon: "pi pi-list" },
        { label: "Event", icon: "pi pi-calendar-clock" },
        { label: "Other", icon: "pi pi-ellipsis-h" },
      ],
    },
    {
      label: "More",
      icon: "pi pi-ellipsis-h",
      items: [
        { 
          label: "Attachments", 
          icon: "pi pi-link",
          command: () => {
            if (!selectedCompany) {
              toast.current?.show({
                severity: 'warn',
                summary: 'No Selection',
                detail: 'Please select a company first.'
              });
              return;
            }
            // You can implement single company attachment here
            // For now, we'll show a message to use the bulk action
            toast.current?.show({
              severity: 'info',
              summary: 'Use Bulk Action',
              detail: 'Please select companies from the table and use the "More" dropdown for bulk attachments.'
            });
          }
        },
        { 
          label: "Change Status", 
          icon: "pi pi-sync",
          command: () => {
            if (!selectedCompany) {
              toast.current?.show({
                severity: 'warn',
                summary: 'No Selection',
                detail: 'Please select a company first.'
              });
              return;
            }
            // You can implement single company status change here
            toast.current?.show({
              severity: 'info',
              summary: 'Use Bulk Action',
              detail: 'Please select companies from the table and use the "More" dropdown for bulk status changes.'
            });
          }
        },
        {
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            if (selectedCompany) {
              handleDeleteCompany(selectedCompany);
            }
          }
        }
      ],
    },
    { label: "Company Notes", icon: "pi pi-clipboard" },
    { label: "Export", icon: "pi pi-file-export" },
    {
      label: "Clear Search",
      icon: "pi pi-sync",
      command: () => handleClearSearchCompanies(),
    },
  ]

  // Function to handle closing the view sidebar
  const handleCloseViewSidebar = () => {
    setVisibleViewRight(false);
    // Clear project, work type, and notes data when sidebar is closed
    setCurrentViewedCompany(null);
    setProjectData([]);
    setProjectsLoading(false);
    setCompanyProjects([]);
    setWorkTypesLoading(false);
    setCandidateNotes([]);
    setNotesLoading(false);
    // Also clear notes editor state
    setEditorVisible(false);
    setEditorContent("");
    setEditIndex(null);
    setSelectedCompanyData([]);
  };

  // Function to handle viewing a company
  const viewCompany = company => {
    toast.current.show({
      severity: "info",
      summary: "Company Selected",
      detail: company.company,
    })
  }

  // Function to handle editing a company
  const editCompany = company => {
    toast.current.show({
      severity: "success",
      summary: "Edit Company",
      detail: `Editing ${company.firstName} ${company.lastName}`,
    })
  }

  // Function to handle deleting a company
  const handleDeleteCompany = async (company) => {
    try {
      if (!company || !(company.id || company.pk || company.company_id)) {
        toast.current?.show({ severity: 'error', summary: 'Delete failed', detail: 'No id found for selected company.' });
        return;
      }

      console.log('Deleting company:', company);
      const res = await deleteCompany(company.id || company.pk || company.company_id);

      // backend-helper returns response.data; backend sends { status_code: 200, message: '...' }
      if (res && (res.status_code === 200 || res.status === 200)) {
        // Update all related state arrays only after successful API response
        setCompanyData(prev => prev.filter(c => (c.id || c.pk || c.company_id) !== (company.id || company.pk || company.company_id)));
        if (typeof customers !== 'undefined') {
          setCustomers(prev => prev.filter(c => (c.id || c.pk || c.company_id) !== (company.id || company.pk || company.company_id)));
        }
        if (typeof compamyitem !== 'undefined') {
          setcompamyitem(prev => prev.filter(c => (c.id || c.pk || c.company_id) !== (company.id || company.pk || company.company_id)));
        }

        toast.current?.show({
          severity: 'success',
          summary: res.message || 'Company Deleted',
          detail: `${company.company_name || company.company || 'Company'} deleted`,
        });
      } else {
        console.error('Delete API returned error:', res);
        toast.current?.show({ severity: 'error', summary: 'Delete failed', detail: (res && res.message) || 'Failed to delete company.' });
      }
    } catch (error) {
      console.error('Error deleting company:', error);
      const message = error?.response?.data?.message || error?.message || 'Failed to delete company. Please try again.';
      toast.current?.show({ severity: 'error', summary: 'Error', detail: message });
    }
  };

  // context menu ends


  const handleArchiveCompany = (id) => {
    console.log(selectedCompanyData?.id,'duiasdhaiushudiashdu');
    
      if (selectedCompanyData && selectedCompanyData.length > 0) {
        selectedCompanyData.forEach(async (element) => {
          // Call the archive API for each selected employee
          try {
           const response = await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/companies/${element.id}/`, { is_archived: false }, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            if (response.status === 200) {
              toast.current.show({ severity: 'success', summary: 'Success', detail: `Project archived successfully` });
              // getAllActive(pageState.page, pageState.rows);
              setSelectedCompany([]);
              setSelectedCompanyData([]);
              getCompanydata()
            }
            console.log(`Archived project with ID: ${element.id}`);
          } catch (error) {
            console.error(`Error archiving project ${element.id}:`, error);
          }
        });
      }
    }

  



 

  

 

  // view form activities starts

  const [activitiesFilters, setActivitiesFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    sub_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.DATE_IS },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const activities = [
    {
      type: "Call",
      sub_type: "Introductory Call",
      priority: "High",
      subject: "Call Request to Discuss Project Updates",
      date_time: "01-01-2025 10:00",
      user_id: "mahesh",
    },
    {
      type: "Meeting",
      sub_type: "Daily Stand-up",
      priority: "Medium",
      subject: "Project Progress and Next Steps",
      date_time: "05-12-2024 09:00",
      user_id: "lavan",
    },
    {
      type: "Event",
      sub_type: "Follow-up Call",
      priority: "Low",
      subject: "Meeting Request",
      date_time: "15-01-2025 14:00",
      user_id: "ruchitha",
    },
    {
      type: "Others",
      sub_type: "Requirement Discussion",
      priority: "High",
      subject: "Discussion on Future Milestones",
      date_time: "01-02-2025 11:00",
      user_id: "laxmi",
    },
    {
      type: "Call",
      sub_type: "Follow-up Call",
      priority: "Critical",
      subject: "Need to Discuss Project Status",
      date_time: "01-03-2025 13:00",
      user_id: "rajashekar",
    },
  ]

  const [selectedActivities, setSelectedActivities] = useState([])

  // view form activities ends


  // view form Projects start

  // State to track the currently viewed company
  const [currentViewedCompany, setCurrentViewedCompany] = useState(null);
  const [projectsLoading, setProjectsLoading] = useState(false);

  const [projectData, setProjectData] = useState([
    {
      project_code: "Proj-101",
      project_name: "AI Generator",
      project_manager: "Mahesh Kumar Bhoga",
      task_count: "13",
      completed_tasks: "9",
      delay_reason: "Due to some issues",
      status: "Open",
      extended_end_date: "24-05-2025",
      experience_required: "3 Years",
      project_start_date: "01-01-2025",
      project_end_date: "31-12-2025",
    },
  ]);

  const [selectedProjects, setSelectedProjects] = useState([]);

  const [projectDataFilters, setProjectDataFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    project_code: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    project_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    project_manager: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_count: { value: null, matchMode: FilterMatchMode.EQUALS },
    completed_tasks: { value: null, matchMode: FilterMatchMode.EQUALS },
    delay_reason: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    extended_end_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    experience_required: { value: null, matchMode: FilterMatchMode.CONTAINS },
    project_start_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    project_end_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const dateFilterTemplate = (options) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        dateFormat="dd-mm-yy"
        placeholder="dd-mm-yyyy"
        mask="99-99-9999"
      />
    );
  };

  // Function to fetch projects for a specific company
  const fetchCompanyProjects = async (companyId) => {
    if (!companyId) {
      console.log("No company ID provided for fetching projects");
      return;
    }

    setProjectsLoading(true);
    try {
      console.log("Fetching projects for company ID:", companyId);
      
      // Fetch projects with company filter parameter
      // Try different parameter names in case the backend expects something different
      const response = await getProjects({ company: companyId });
      
      console.log("Raw projects response:", response);
      
      let projects = [];
      if (Array.isArray(response)) {
        projects = response;
      } else if (response && Array.isArray(response.results)) {
        projects = response.results;
      } else if (response && Array.isArray(response.data)) {
        projects = response.data;
      } else if (response && Array.isArray(response.projects)) {
        projects = response.projects;
      } else if (response && response.count !== undefined) {
        // Django REST Framework pagination format
        projects = response.results || [];
      }
      
      console.log("Processed projects:", projects);
      console.log("Number of projects found:", projects.length);
      
      // Transform the projects data to match the expected format
      const transformedProjects = projects.map(project => ({
        id: project.id,
        project_code: project.code || project.project_code || `PROJ-${project.id}`,
        project_name: project.name || project.project_name || project.title || 'Unnamed Project',
        project_manager: project.project_manager 
          ? (typeof project.project_manager === 'object' 
              ? `${project.project_manager.first_name || ''} ${project.project_manager.last_name || ''}`.trim() || project.project_manager.email
              : project.project_manager)
          : project.manager || project.created_by || '',
        task_count: project.task_count || project.tasks_count || "0",
        completed_tasks: project.completed_tasks || project.completed_count || "0",
        delay_reason: project.reason_for_delay || project.delay_reason || "",
        status: project.project_status_name ,
        extended_end_date: project.extended_end_date || project.end_date || "",
        experience_required: project.experience_required || "",
        project_start_date: project.start_date || project.project_start_date || "",
        project_end_date: project.end_date || project.project_end_date || "",
        // Add any other fields that might be in the API response
        description: project.description || "",
        company: project.company,
        delivery_manager: project.delivery_manager
          ? (typeof project.delivery_manager === 'object'
              ? `${project.delivery_manager.first_name || ''} ${project.delivery_manager.last_name || ''}`.trim() || project.delivery_manager.email
              : project.delivery_manager)
          : '',
        created_at: project.created_at,
        updated_at: project.updated_at
      }));
      
      setProjectData(transformedProjects);
      console.log("Updated project data:", transformedProjects);
      
    } catch (error) {
      console.error("Error fetching company projects:", error);
      console.error("Error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      // On error, set empty array and show message
      setProjectData([]);
    } finally {
      setProjectsLoading(false);
    }
  };

  // Function to fetch work types for a specific company
  const fetchCompanyWorkTypes = async (companyId) => {
    if (!companyId) {
      console.log("No company ID provided for fetching work types");
      return;
    }

    setWorkTypesLoading(true);
    try {
      console.log("Fetching work types for company ID:", companyId);
      
      // Fetch work types with company filter parameter
      const response = await getWorkTypes({ company: companyId });
      
      console.log("Raw work types response:", response);
      
      let workTypes = [];
      if (Array.isArray(response)) {
        workTypes = response;
      } else if (response && Array.isArray(response.results)) {
        workTypes = response.results;
      } else if (response && Array.isArray(response.data)) {
        workTypes = response.data;
      } else if (response && Array.isArray(response.worktypes)) {
        workTypes = response.worktypes;
      } else if (response && response.count !== undefined) {
        // Django REST Framework pagination format
        workTypes = response.results || [];
      }
      
      console.log("Processed work types:", workTypes);
      console.log("Number of work types found:", workTypes.length);
      
      // Transform the work types data to match the expected format
      const transformedWorkTypes = workTypes.map(workType => ({
        
        id: workType.id,
        task_code: workType.code || `TASK-${workType.id}`,
        task_type: workType.work_type_name || "Task",

        project_name: workType.project_name
          ? `${workType.project_name} (${workType.project_code || ''})`
          : "No Project",

        project_manager: workType.project_manager_name || "",

        module_name: workType.module || workType.module_name || "",

        task_name: workType.summary || "",
        task_description: workType.description || "",

        created_by: workType.created_by || "",
        assigned_by: workType.assigned_by || "",
        assigned_to: workType.assigned_to_employee_name || "",

        watchers: workType.watchers || "",

        start_date: workType.start_date || "",
        end_date: workType.end_date || "",
        actual_end_date: workType.actual_end_date || "",

        work_hours: workType.work_hours || workType.estimated_hours || workType.hours || 0,

        task_status: workType.work_type_status_name || "To Do",
        priority: workType.priority || "Medium",
        approval_status: workType.approval_status || "Pending",

        company: workType.company || "",
        project: workType.project || workType.project_name || "",
        created_at: workType.created_at || "",
        updated_at: workType.updated_at || ""
      }));

      
      setCompanyProjects(transformedWorkTypes);
      console.log("Updated work types data:", transformedWorkTypes);
      
    } catch (error) {
      console.error("Error fetching company work types:", error);
      console.error("Error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      // On error, set empty array
      setCompanyProjects([]);
    } finally {
      setWorkTypesLoading(false);
    }
  };

  // Function to fetch notes for a specific company
  const fetchCompanyNotes = async (companyId) => {
    if (!companyId) {
      console.log("No company ID provided for fetching notes");
      return;
    }

    setNotesLoading(true);
    try {
      console.log("Fetching notes for company ID:", companyId);
      
      // Fetch notes for this company using the entity notes API
      const response = await getEntityNotes('companies', companyId);
      
      console.log("Raw notes response:", response);
      
      let notes = [];
      if (Array.isArray(response)) {
        notes = response;
      } else if (response && Array.isArray(response.results)) {
        notes = response.results;
      } else if (response && Array.isArray(response.data)) {
        notes = response.data;
      } else if (response && Array.isArray(response.notes)) {
        notes = response.notes;
      }
      
      console.log("Processed notes:", notes);
      console.log("Number of notes found:", notes.length);
      
      // Transform the notes data to match the expected format
      const transformedNotes = notes.map((note, index) => ({
        id: note.id,
        content: note.content || note.description || note.text || "",
        timestamp: note.created_at 
          ? `Saved on: ${new Date(note.created_at).toLocaleString()}`
          : `Note ${index + 1}`,
        candidateName: note.created_by_name ,
        created_at: note.created_at,
        updated_at: note.updated_at,
        // Keep original note data for updates
        originalNote: note
      }));
      
      setCandidateNotes(transformedNotes);
      console.log("Updated notes data:", transformedNotes);
      
    } catch (error) {
      console.error("Error fetching company notes:", error);
      console.error("Error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      // On error, set empty array
      setCandidateNotes([]);
    } finally {
      setNotesLoading(false);
    }
  };

  // view form Projects end


  // View worktype start
  
  // State for work types loading and data
  const [workTypesLoading, setWorkTypesLoading] = useState(false);

  const CompanyProjects = [
    {
      task_code: "Task-101",
      task_type: "Task",
      project_name: "AI Generator (Proj-101)",
      project_manager: "Sneha Mehta",
      module_name: "User Management",
      task_name: "Add User Role Feature",
      task_description: "Implement feature to add roles to a user account.",
      created_by: "Ravi Sharma",
      assigned_by: "Sneha Mehta",
      assigned_to: "Amit Verma",
      watchers: "Ravi Sharma, Sneha Mehta",
      start_date: "01-05-2025",
      work_hours: 12,
      end_date: "03-05-2025",
      actual_end_date: "02-05-2025",
      task_status: "To Do",
      priority: "High",
      approval_status: "Approved",
    },
    {
      task_code: "STask-101.1",
      task_type: "Sub Task",
      project_name: "AI Generator (Proj-101)",
      project_manager: "Ankit Sinha",
      module_name: "Reporting",
      task_name: "Generate Monthly Report",
      task_description: "Automate monthly report generation for sales team.",
      created_by: "Priya Desai",
      assigned_by: "Ankit Sinha",
      assigned_to: "Kiran Rao",
      watchers: "Ankit Sinha",
      start_date: "04-05-2025",
      work_hours: 8,
      end_date: "05-05-2025",
      actual_end_date: "08-05-2025",
      task_status: "In Progress",
      priority: "Medium",
      approval_status: "Pending",
    },
    {
      task_code: "STask-101.2",
      task_type: "Sub Task",
      project_name: "AI Generator (Proj-101)",
      project_manager: "Rahul Nair",
      module_name: "Authentication",
      task_name: "Fix Login Timeout Bug",
      task_description: "Resolve issue where session times out too early.",
      created_by: "Meena Iyer",
      assigned_by: "Rahul Nair",
      assigned_to: "Vikram Joshi",
      watchers: "Meena Iyer, Rahul Nair",
      start_date: "02-05-2025",
      work_hours: 5,
      end_date: "03-05-2025",
      actual_end_date: "03-05-2025",
      task_status: "In Review",
      priority: "High",
      approval_status: "Approved",
    },
    {
      task_code: "Bug-101.1",
      task_type: "Bug",
      project_name: "AI Generator (Proj-101)",
      project_manager: "Rakesh Kumar",
      module_name: "Payroll Management",
      task_name: "Integrate PF Calculation",
      task_description:
        "Add logic to calculate Provident Fund based on salary slabs.",
      created_by: "Anita Reddy",
      assigned_by: "Rakesh Kumar",
      assigned_to: "Sanjay Mishra",
      watchers: "Anita Reddy, Rakesh Kumar",
      start_date: "04-05-2025",
      work_hours: 10,
      end_date: "06-05-2025",
      actual_end_date: "06-05-2025",
      task_status: "Testing / QA",
      priority: "Medium",
      approval_status: "Approved",
    },
    {
      task_code: "Task-102",
      task_type: "Task",
      project_name: "AI Generator (Proj-101)",
      project_manager: "Neha Jain",
      module_name: "E-Invoice Integration",
      task_name: "Connect with GSTN APIs",
      task_description:
        "Establish API connectivity with the GST Network for invoice validation.",
      created_by: "Suresh Babu",
      assigned_by: "Neha Jain",
      assigned_to: "Rajeev Menon",
      watchers: "Suresh Babu, Neha Jain",
      start_date: "03-05-2025",
      work_hours: 16,
      end_date: "07-05-2025",
      actual_end_date: "07-05-2025",
      task_status: "Blocked",
      priority: "High",
      approval_status: "Pending",
    },
    {
      task_code: "STask-102.1",
      task_type: "Sub Task",
      project_name: "AI Generator (Proj-101)",
      project_manager: "Vikas Patil",
      module_name: "Attendance Tracking",
      task_name: "Add Biometric Sync",
      task_description:
        "Implement sync between biometric device and central attendance module.",
      created_by: "Harsha Shetty",
      assigned_by: "Vikas Patil",
      assigned_to: "Nikhil Kapoor",
      watchers: "Harsha Shetty",
      start_date: "01-05-2025",
      work_hours: 6,
      end_date: "02-05-2025",
      actual_end_date: "02-05-2025",
      task_status: "Done",
      priority: "Low",
      approval_status: "Approved",
    },
    {
      task_code: "Bug-102.1",
      task_type: "Bug",
      project_name: "AI Generator (Proj-101)",
      project_manager: "Manoj Bhatt",
      module_name: "Leave Management",
      task_name: "Bug Fix - Overlapping Leaves",
      task_description:
        "Fix the bug where multiple overlapping leaves are allowed.",
      created_by: "Deepika Saini",
      assigned_by: "Manoj Bhatt",
      assigned_to: "Alok Yadav",
      watchers: "Deepika Saini, Manoj Bhatt",
      start_date: "05-05-2025",
      work_hours: 4,
      end_date: "06-05-2025",
      actual_end_date: "07-05-2025",
      task_status: "Cancelled",
      priority: "Medium",
      approval_status: "Pending",
    },
    {
      task_code: "Bug-102.2",
      task_type: "Bug",
      project_name: "AI Generator (Proj-101)",
      project_manager: "Karthik Rao",
      module_name: "Performance Evaluation",
      task_name: "Add Employee Self-Review",
      task_description:
        "Develop form for employees to submit self-evaluation before appraisals.",
      created_by: "Anjali Menon",
      assigned_by: "Karthik Rao",
      assigned_to: "Tarun Singh",
      watchers: "Anjali Menon",
      start_date: "02-05-2025",
      work_hours: 9,
      end_date: "04-05-2025",
      actual_end_date: "03-05-2025",
      task_status: "To Do",
      priority: "High",
      approval_status: "Approved",
    },
    {
      task_code: "Task-103",
      task_type: "Task",
      project_name: "AI Generator (Proj-101)",
      project_manager: "Nitin Sharma",
      module_name: "Project Dashboard",
      task_name: "Create Gantt Chart View",
      task_description: "Add a Gantt chart to visualize project timelines.",
      created_by: "Rajashree Banerjee",
      assigned_by: "Nitin Sharma",
      assigned_to: "Amit Choudhary",
      watchers: "Rajashree Banerjee, Nitin Sharma",
      start_date: "06-05-2025",
      work_hours: 14,
      end_date: "09-05-2025",
      actual_end_date: "07-05-2025",
      task_status: "In Progress",
      priority: "High",
      approval_status: "Pending",
    },
    {
      task_code: "STask-103.1",
      task_type: "Sub Task",
      project_name: "AI Generator (Proj-101)",
      project_manager: "Arun Pillai",
      module_name: "Notification Center",
      task_name: "Add SMS Alert Integration",
      task_description: "Integrate Twilio API to send SMS alerts to users.",
      created_by: "Pooja Srinivasan",
      assigned_by: "Arun Pillai",
      assigned_to: "Rohit Varma",
      watchers: "Pooja Srinivasan",
      start_date: "04-05-2025",
      work_hours: 7,
      end_date: "05-05-2025",
      actual_end_date: "05-05-2025",
      task_status: "In Review",
      priority: "Medium",
      approval_status: "Approved",
    },
    {
      task_code: "Bug-103.1",
      task_type: "Bug",
      project_name: "AI Generator (Proj-101)",
      project_manager: "Devansh Goyal",
      module_name: "File Management",
      task_name: "Optimize File Uploads",
      task_description: "Improve file upload speed and add progress indicator.",
      created_by: "Sneha Rathi",
      assigned_by: "Devansh Goyal",
      assigned_to: "Ravi Sekhar",
      watchers: "Sneha Rathi, Devansh Goyal",
      start_date: "03-05-2025",
      work_hours: 6,
      end_date: "04-05-2025",
      actual_end_date: "04-05-2025",
      task_status: "Completed",
      priority: "Low",
      approval_status: "Approved",
    },
  ]

  const [companyProjects, setCompanyProjects] = useState([])  // Initialize with empty array to be populated by API
  const [selectedCompanyProjects, setSelectedCompanyProjects] = useState([])

  const [companyProjectFilters, setCompanyProjectFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    task_code: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    project_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    project_manager: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    module_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_description: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_by: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    assigned_by: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    assigned_to: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    watchers: { value: null, matchMode: FilterMatchMode.CONTAINS },
    start_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    end_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    actual_end_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    work_hours: { value: null, matchMode: FilterMatchMode.EQUALS },
    task_status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    approval_status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  

  // View worktype end

  // view form notes starts

  const [isEditorVisible, setEditorVisible] = useState(false) // Manage editor visibility
  const [editorContent, setEditorContent] = useState("") // Manage editor content
  const [editIndex, setEditIndex] = useState(null)
  const [candidateNotes, setCandidateNotes] = useState([]) // Store notes in an array
  const [notesLoading, setNotesLoading] = useState(false) // Loading state for notes API calls

  const handleAddNotes = () => {
    setEditorVisible(true) // Show the editor
    setEditorContent("") // Clear any previous content
    setEditIndex(null) // Reset editIndex when adding a new note
  }

  const handleSaveNotes = async () => {
    if (!editorContent.trim()) {
      console.log("No content to save");
      return;
    }

    if (!currentViewedCompany) {
      console.error("No company selected for saving notes");
      return;
    }

    const companyId = currentViewedCompany.id || currentViewedCompany.pk || currentViewedCompany.company_id;
    if (!companyId) {
      console.error("No valid company ID found for saving notes");
      return;
    }

    setNotesLoading(true);
    try {
      console.log("Saving note for company ID:", companyId);
      
      const noteData = {
        content: editorContent.trim(),
        // Add any other required fields based on your API
      };

      if (editIndex !== null) {
        // Update existing note
        const noteToEdit = candidateNotes[editIndex];
        if (!noteToEdit.id) {
          console.error("No note ID found for editing");
          return;
        }

        console.log("Updating existing note with ID:", noteToEdit.id);
        const response = await updateEntityNote('companies', companyId, noteToEdit.id, noteData);
        console.log("Note update response:", response);
        
        // Refresh the notes list to show the updated note
        await fetchCompanyNotes(companyId);
        setEditIndex(null);
        
      } else {
        // Create a new note
        console.log("Creating new note with data:", noteData);
        const response = await createEntityNote('companies', companyId, noteData);
        console.log("Note creation response:", response);
        
        // Refresh the notes list to show the new note
        await fetchCompanyNotes(companyId);
      }

      // Clear editor and hide it
      setEditorContent("");
      setEditorVisible(false);

    } catch (error) {
      console.error("Error saving note:", error);
      console.error("Error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      
      // Show error message to user (you might want to use a toast notification)
      alert("Failed to save note. Please try again.");
      
    } finally {
      setNotesLoading(false);
    }
  };

  const handleCancelNotes = () => {
    setEditorContent("") // Clear editor content
    setEditIndex(null) // Reset editIndex on cancel
    setEditorVisible(false) // Hide the editor
  }

  const handleEditNote = index => {
    setEditorVisible(true)
    setEditorContent(candidateNotes[index].content) // Load the note content into the editor
    setEditIndex(index) // Set editIndex to edit the current note
  }

  const handleDeleteNote = async (index) => {
    if (!currentViewedCompany) {
      console.error("No company selected for deleting note");
      return;
    }

    const companyId = currentViewedCompany.id || currentViewedCompany.pk || currentViewedCompany.company_id;
    if (!companyId) {
      console.error("No valid company ID found for deleting note");
      return;
    }

    const noteToDelete = candidateNotes[index];
    if (!noteToDelete.id) {
      console.error("No note ID found for deletion");
      return;
    }

    // Confirm deletion
    if (!window.confirm("Are you sure you want to delete this note?")) {
      return;
    }

    setNotesLoading(true);
    try {
      console.log("Deleting note with ID:", noteToDelete.id);
      const response = await deleteEntityNote('companies', companyId, noteToDelete.id);
      console.log("Note deletion response:", response);
      
      // Refresh the notes list to remove the deleted note
      await fetchCompanyNotes(companyId);
      
    } catch (error) {
      console.error("Error deleting note:", error);
      console.error("Error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      
      // Show error message to user
      alert("Failed to delete note. Please try again.");
      
    } finally {
      setNotesLoading(false);
    }
  }

  // view form notes ends

  // view form history starts

  const [historyFilters, setHistoryFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    sub_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.DATE_IS },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const history = [
   
    {
      type: "Meeting",
      sub_type: "Daily Stand-up",
      priority: "Medium",
      subject: "Project Progress and Next Steps",
      date_time: "05-12-2024 09:00",
      user_id: "lavan",
    },
    {
      type: "Call",
      sub_type: "Introductory Call",
      priority: "High",
      subject: "Call Request to Discuss Project Updates",
      date_time: "01-01-2025 10:00",
      user_id: "mahesh",
    },
    {
      type: "Event",
      sub_type: "Follow-up Call",
      priority: "Low",
      subject: "Meeting Request",
      date_time: "15-01-2025 14:00",
      user_id: "ruchitha",
    },
   
    {
      type: "Call",
      sub_type: "Follow-up Call",
      priority: "Critical",
      subject: "Need to Discuss Project Status",
      date_time: "01-03-2025 13:00",
      user_id: "rajashekar",
    },
     {
      type: "Others",
      sub_type: "Requirement Discussion",
      priority: "High",
      subject: "Discussion on Future Milestones",
      date_time: "01-02-2025 11:00",
      user_id: "laxmi",
    },
  ]

  const [selectedHistory, setSelectedHistory] = useState([])

  // view form history ends

  // view form contacts starts



  const contacts = [
    {
      full_name: "Mahesh Kumar Bhoga",
    designation: "UI/UX Manager",
      work_phone: "040 456 7890",
      work_email: "mahesh9@varundigitalmedia.com",
      city: "Hyderabad",
      user_id: "Harish",
    },

    {
      full_name: "Salmanuddin Syed",
    designation: "Operation Head",
      work_phone: "040 654 3210",
      work_email: "salman@varundigitalmedia.com",
      city: "Hyderabad",
      user_id: "Haish",
    },
  ]


  // view form contacts ends

  // view form candidates starts

  const [candidatesFilters, setCandidatesFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    full_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  designation: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    mob_phone: { value: null, matchMode: FilterMatchMode.CONTAINS },
    email: { value: null, matchMode: FilterMatchMode.CONTAINS },
    city: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const candidates = [
    {
      full_name: "John Doe",
    designation: "Frontend Developer",
      mob_phone: "(123) 456-7890",
      email: "john.doe@example.com",
      city: "New York",
      user_id: "2001",
    },
    {
      full_name: "Jane Smith",
    designation: "Backend Developer",
      mob_phone: "(987) 654-3210",
      email: "jane.smith@example.com",
      city: "San Francisco",
      user_id: "2002",
    },
    {
      full_name: "Emily Davis",
    designation: "Full Stack Engineer",
      mob_phone: "(456) 789-1234",
      email: "emily.davis@example.com",
      city: "Chicago",
      user_id: "2003",
    },
    {
      full_name: "Michael Brown",
    designation: "UI/UX Designer",
      mob_phone: "(789) 123-4567",
      email: "michael.brown@example.com",
      city: "Los Angeles",
      user_id: "2004",
    },
    {
      full_name: "Sarah Wilson",
    designation: "Product Manager",
      mob_phone: "(321) 654-9870",
      email: "sarah.wilson@example.com",
      city: "Seattle",
      user_id: "2005",
    },
  ]

  const [selectedCandidates, setSelectedCandidates] = useState([])

  // view form candidates ends

  const [visibleViewRight, setVisibleViewRight] = useState(false)
  const [editingDocument, setEditingDocument] = useState(null)
  const [documentEditDialog, setDocumentEditDialog] = useState(false)
  const [editDocumentData, setEditDocumentData] = useState({ 
    type: '', 
    description: '',
    name: ''
  })
  const [documents, setDocuments] = useState([])
  const [loadingDocuments, setLoadingDocuments] = useState(false)
  const EditId= selectedCompanyData[0]?.id;
const getDocuments =async (id)=>
    {
      try
      {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/companies/${EditId}/documents/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200) {
          const apiData = response.data.data;
         setDocuments(apiData);
        }
      }catch(err) 
      {
        console.log(err);
        
      }
    }
  // Function to fetch real documents from database
  const fetchCompanyDocuments = async (companyId) => {
    if (!companyId) return;
    
    setLoadingDocuments(true);
    try {
      console.log('Fetching documents for company ID:', companyId);
      const response = await getEntityDocuments('companies', companyId);
      console.log('Documents response:', response);
      console.log('Raw document data:', response.data);
      if (response.data && response.data.length > 0) {
        console.log('First document structure:', response.data[0]);
        console.log('First document file field:', response.data[0].file);
        console.log('First document name field:', response.data[0].name);
      }
      
      // Transform the documents data to match the TreeTable format
      const transformedDocuments = response.data.map((doc, index) => {
        // Better filename extraction
        let filename = 'No filename';
        if (doc.file) {
          // Extract filename from URL, handling different URL formats
          const urlParts = doc.file.split('/');
          filename = urlParts[urlParts.length - 1];
          // If filename has query parameters, remove them
          if (filename.includes('?')) {
            filename = filename.split('?')[0];
          }
          // Decode URL encoding if present
          try {
            filename = decodeURIComponent(filename);
          } catch (e) {
            // If decoding fails, use the original filename
          }
        } else if (doc.name) {
          filename = doc.name;
        }
        
        return {
          key: doc.id.toString(),
          data: {
            id: doc.id,
            docType: doc.type || 'Document',
            docSubject: doc.description || filename,
            appliedDateTime: new Date(doc.created_at).toLocaleString(),
            fileUrl: doc.file,
            fileName: filename,
            originalDoc: doc // Store original document data for editing
          }
        };
      });
      
      console.log('Transformed documents:', transformedDocuments);
      // setDocuments(response.data);
      
    } catch (error) {
      console.error('Error fetching company documents:', error);
      // Fallback to empty array if error
      // setDocuments([]);
    } finally {
      setLoadingDocuments(false);
    }
  };

  // Handle document download/view
  const handleDocumentDownload = (document) => {
    if (document.fileUrl) {
      console.log('Opening document:', document.fileUrl);
      window.open(document.fileUrl, '_blank');
      toast.current.show({
        severity: 'info',
        summary: 'Opening Document',
        detail: `Opening ${document.fileName}`,
        life: 3000
      });
    } else {
      toast.current.show({
        severity: 'warn',
        summary: 'No File Available',
        detail: 'This document does not have an associated file',
        life: 3000
      });
    }
  };

  // Handle document edit
  const handleDocumentEdit = (document) => {
    console.log('Editing document:', document);
    setEditingDocument(document);
    setEditDocumentData({
      type: document.docType || '',
      description: document.docSubject || '',
      name: document.fileName || ''
    });
    setDocumentEditDialog(true);
  };

  // Handle document update/save
  const handleDocumentUpdate = async () => {
    if (!editingDocument || !currentViewedCompany) return;
    
    try {
      const companyId = currentViewedCompany.id || currentViewedCompany.pk || currentViewedCompany.company_id;
      const documentId = editingDocument.id;
      
      const updateData = {
        type: editDocumentData.type,
        description: editDocumentData.description,
        name: editDocumentData.name
      };

      console.log('Updating document:', { companyId, documentId, updateData });
      
      await updateEntityDocument('companies', companyId, documentId, updateData);
      
      // Refresh documents list
      await fetchCompanyDocuments(companyId);
      
      toast.current.show({
        severity: 'success',
        summary: 'Document Updated',
        detail: 'Document has been updated successfully',
        life: 3000
      });
      
      setDocumentEditDialog(false);
      setEditingDocument(null);
      
    } catch (error) {
      console.error('Error updating document:', error);
      toast.current.show({
        severity: 'error',
        summary: 'Update Failed',
        detail: error.response?.data?.message || 'Failed to update document',
        life: 5000
      });
    }
  };

  // Handle document delete
  const handleDocumentDelete = async (document) => {
    if (!currentViewedCompany) return;
    
    // Confirm deletion
    if (!window.confirm(`Are you sure you want to delete "${document.fileName}"?`)) {
      return;
    }
    
    try {
      const companyId = currentViewedCompany.id || currentViewedCompany.pk || currentViewedCompany.company_id;
      const documentId = document.id;
      
      console.log('Deleting document:', { companyId, documentId });
      
      await deleteEntityDocument('companies', companyId, documentId);
      
      // Refresh documents list
      await fetchCompanyDocuments(companyId);
      
      toast.current.show({
        severity: 'success',
        summary: 'Document Deleted',
        detail: `${document.fileName} has been deleted successfully`,
        life: 3000
      });
      
    } catch (error) {
      console.error('Error deleting document:', error);
      toast.current.show({
        severity: 'error',
        summary: 'Delete Failed',
        detail: error.response?.data?.message || 'Failed to delete document',
        life: 5000
      });
    }
  };

  // Delete a single company row (API + state)
  const handleDeleteRow = async (rowData) => {
    try {
      const id = rowData?.id || rowData?.pk || rowData?.company_id;
      if (!id) {
        toast.current?.show({ severity: 'error', summary: 'Delete failed', detail: 'No id found for selected row.' });
        return;
      }
      const res = await deleteCompany(id);
      if (res && (res.status_code === 200 || res.status === 200)) {
        setCompanyData(prev => prev.filter(r => (r.id || r.pk || r.company_id) !== id));
        setSelectedCompanyData(prev => prev.filter(r => (r.id || r.pk || r.company_id) !== id));
        toast.current?.show({ severity: 'success', summary: res.message || 'Deleted', detail: `Company id=${id} deleted.` });
      } else {
        console.error('Delete API returned error for row:', res);
        toast.current?.show({ severity: 'error', summary: 'Delete failed', detail: (res && res.message) || 'Could not delete company.' });
      }
    } catch (err) {
      console.error('Error deleting row:', err);
      const message = err?.response?.data?.message || err?.message || 'Could not delete company.';
      toast.current?.show({ severity: 'error', summary: 'Delete failed', detail: message });
    }
  }

  // Simple display template for document fields
  const editableTemplate = (rowData, field) => {
    const value = rowData.data[field];
    return (
      <span 
        title={value} 
        style={{ 
          wordBreak: 'break-all', 
          whiteSpace: 'normal',
          maxWidth: '200px',
          display: 'inline-block'
        }}
      >
        {value}
      </span>
    );
  }

  // Action buttons for documents
  const actionTemplate = rowData => {
    return (
      <div className="flex gap-2">
        {/* Download/View button for documents with file URLs */}
        {rowData.data.fileUrl && (
          <Button
            icon="pi pi-download"
            rounded
            outlined
            severity="info"
            className="document-btn"
            title="Download/View Document"
            onClick={() => handleDocumentDownload(rowData.data)}
          />
        )}
        
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          severity="warning"
          className="document-btn"
          title="Edit Document"
          onClick={() => handleDocumentEdit(rowData.data)}
        />
        
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          className="document-btn"
          title="Delete Document"
          onClick={() => handleDocumentDelete(rowData.data)}
        />
      </div>
    )
  }

  // view page ends

  const [showesitSelecticon, setshowesitSelecticon] = useState(false)
  const [showesitSelect, setshowesitSelect] = useState(true)
  const [showIconsSelect, setShowIconsSelect] = useState(false)

  const [selectedSchedule, setSelectedSchedule] = useState(null)

 

  const handleScheduleChange = e => {
    setSelectedSchedule(e.value)
    setIntertype(e.value.name) // Update input field with selected name

    // Trigger the action if it exists
    if (e.value && e.value.action) {
      e.value.action()
    }
  }


  const moreoptions = [
    {
      name: "Attachments",
    },
    {
      name: "Change Status",
    },
    {
      name: "Delete",
    },
  ]

  // clear search start

  const handleClearSearchCompanies = () => {
    console.log("clicked")

    setFilters({
      company: { value: null, matchMode: FilterMatchMode.CONTAINS },
      website: { value: null, matchMode: FilterMatchMode.CONTAINS },
      industry: { value: null, matchMode: FilterMatchMode.CONTAINS },
      companySize: { value: null, matchMode: FilterMatchMode.CONTAINS },
      yearFounded: { value: null, matchMode: FilterMatchMode.CONTAINS },
      overview: { value: null, matchMode: FilterMatchMode.CONTAINS },
      email: { value: null, matchMode: FilterMatchMode.CONTAINS },
      mobilePhone: { value: null, matchMode: FilterMatchMode.CONTAINS },
      address: { value: null, matchMode: FilterMatchMode.CONTAINS },
      notes: { value: null, matchMode: FilterMatchMode.CONTAINS },
      category: { value: null, matchMode: FilterMatchMode.CONTAINS },
      group: { value: null, matchMode: FilterMatchMode.CONTAINS },
      userIds: { value: null, matchMode: FilterMatchMode.CONTAINS },
      createdBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
      lastActivityDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
      createDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
      editDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })

    
  }

 

  //   Delete the selected data

  const [showConfirmDialog, setShowConfirmDialog] = useState(false)

  const handleDeleteSelected = () => {
    setShowConfirmDialog(true)
    console.log("clickeddddddd")
  }

  console.log("Selected data to delete:", selectedCompanyData)
 

  const cancelDelete = () => {
    setShowConfirmDialog(false)
  }

  const confirmDelete = () => {
    (async () => {
      try {
        console.log("Before deletion, companyData:", companyData)
        console.log("Deleting these items:", selectedCompanyData)

        // Delete each selected company via API
        const failedDeletes = [];
        for (const row of selectedCompanyData) {
          const id = row.id || row.pk || row.company_id;
          if (!id) {
            console.warn('Skipping deletion for row without id', row);
            failedDeletes.push({ row, reason: 'no id' });
            continue;
          }
          try {
            const res = await deleteCompany(id);
            if (!(res && (res.status_code === 200 || res.status === 200))) {
              failedDeletes.push({ row, reason: res && res.message ? res.message : 'API error' });
              console.error(`Failed to delete company id=${id}:`, res);
            } else {
              console.log(`Deleted company id=${id}`);
            }
          } catch (err) {
            failedDeletes.push({ row, reason: err?.message || 'Exception' });
            console.error(`Failed to delete company id=${id}:`, err);
            // Show a toast but continue with others
            toast.current?.show({ severity: 'error', summary: 'Delete failed', detail: `Failed to delete company id=${id}` });
          }
        }

        // Remove successfully deleted items from local state
        setCompanyData(prevData => {
          const updatedData = prevData.filter(
            row => !selectedCompanyData.some(selectedRow => (selectedRow.id || selectedRow.pk || selectedRow.company_id) === (row.id || row.pk || row.company_id))
          );
          console.log("After deletion, companyData:", updatedData);
          return updatedData;
        });

        if (failedDeletes.length > 0) {
          toast.current?.show({ severity: 'warn', summary: 'Partial delete', detail: `Some items could not be deleted (${failedDeletes.length}).` });
        } else {
          toast.current?.show({ severity: 'success', summary: 'Deleted', detail: 'Selected company(s) deleted.' });
        }

        setSelectedCompanyData([]); // Clear selection after deletion
        setShowConfirmDialog(false); // Hide the dialog after deletion
        // toast.current?.show({ severity: 'success', summary: 'Deleted', detail: 'Selected company(s) deleted.' });
      } catch (err) {
        console.error('Error during delete operation:', err);
        toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to delete selected items.' });
      }
    })();
  }

  //   delete end

  // Archive selected companies
  const [showArchiveConfirmDialog, setShowArchiveConfirmDialog] = useState(false);

  const handleArchiveSelected = () => {
    if (selectedCompanyData.length === 0) {
      toast.current?.show({
        severity: 'warn',
        summary: 'No Selection',
        detail: 'Please select companies to archive.'
      });
      return;
    }
    setShowArchiveConfirmDialog(true);
  };

  const confirmArchive = async () => {
    try {
      console.log("Archiving these companies:", selectedCompanyData);
      
      const failedArchives = [];
      for (const row of selectedCompanyData) {
        const id = row.id || row.pk || row.company_id;
        if (!id) {
          console.warn('Skipping archive for row without id', row);
          failedArchives.push({ row, reason: 'no id' });
          continue;
        }
        
        try {
          // Use the same pattern as successful updates in the codebase
          const updateData = { 
            ...row, 
            is_archived: true  // Fixed: was is_archive, should be is_archived
          };
          
          console.log('Company row data:', row);
          console.log('Available fields in row:', Object.keys(row));
          console.log('Updating company with data:', updateData);
          console.log('Available fields in updateData:', Object.keys(updateData));
          
          let res;
          try {
            // Try with updateCompany first
            res = await updateCompany(id, updateData);
          } catch (putError) {
            console.log('PUT request failed, trying PATCH:', putError);
            // Fallback to direct PATCH request
            const token = getAuthToken();
            const API_BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api";
            res = await axios.patch(`${API_BASE_URL}/company/companies/${id}/`, 
              { is_archived: true },  // Fixed: was is_archive, should be is_archived
              { 
                headers: { 
                  Authorization: `Bearer ${token}`,
                  'Content-Type': 'application/json'
                } 
              }
            );
            res = res.data; // Extract data from axios response
          }
          
          console.log('Update company response:', res);
          console.log('Response status:', res?.status_code || res?.status);
          console.log('Response data:', res?.data);
          
          if (!(res && (res.status_code === 200 || res.status === 200 || res.id))) {
            failedArchives.push({ row, reason: res && res.message ? res.message : 'API error' });
            console.error(`Failed to archive company id=${id}:`, res);
          } else {
            console.log(`Archived company id=${id}`);
          }
        } catch (err) {
          console.error(`Error archiving company id=${id}:`, err);
          failedArchives.push({ row, reason: err.message || 'Unknown error' });
        }
      }

      if (failedArchives.length > 0) {
        console.warn('Some companies could not be archived:', failedArchives);
        toast.current?.show({ 
          severity: 'warn', 
          summary: 'Partial Success', 
          detail: `${selectedCompanyData.length - failedArchives.length} companies archived, ${failedArchives.length} failed.` 
        });
      } else {
        toast.current?.show({ 
          severity: 'success', 
          summary: 'Archived', 
          detail: `${selectedCompanyData.length} company(s) archived successfully.` 
        });
      }

      // Refresh the data to reflect changes
      await getCompanydata();
      
      setSelectedCompanyData([]); // Clear selection after archiving
      setShowArchiveConfirmDialog(false);
      
    } catch (err) {
      console.error('Error during archive operation:', err);
      toast.current?.show({ 
        severity: 'error', 
        summary: 'Error', 
        detail: 'Failed to archive selected companies.' 
      });
    }
  };

  const cancelArchive = () => {
    setShowArchiveConfirmDialog(false);
  };

  //   archive end

  // More Actions handlers start
  
  // Handle bulk delete from More dropdown
  const handleBulkDeleteCompanies = async (selectedCompanies) => {
    if (!selectedCompanies || selectedCompanies.length === 0) {
      toast.current?.show({
        severity: 'warn',
        summary: 'No Selection',
        detail: 'Please select companies to delete.'
      });
      return;
    }

    try {
      const failedDeletes = [];
      
      for (const company of selectedCompanies) {
        const id = company.id || company.pk || company.company_id;
        if (!id) {
          console.warn('Skipping deletion for company without id', company);
          failedDeletes.push({ company, reason: 'no id' });
          continue;
        }
        
        try {
          const res = await deleteCompany(id);
          if (!(res && (res.status_code === 200 || res.status === 200))) {
            failedDeletes.push({ company, reason: res?.message || 'API error' });
            console.error(`Failed to delete company id=${id}:`, res);
          } else {
            console.log(`Deleted company id=${id}`);
          }
        } catch (err) {
          failedDeletes.push({ company, reason: err?.message || 'Exception' });
          console.error(`Failed to delete company id=${id}:`, err);
        }
      }

      // Remove successfully deleted items from local state
      setCompanyData(prevData => {
        return prevData.filter(
          row => !selectedCompanies.some(selectedRow => 
            (selectedRow.id || selectedRow.pk || selectedRow.company_id) === (row.id || row.pk || row.company_id)
          )
        );
      });

      setCustomers(prevData => {
        return prevData.filter(
          row => !selectedCompanies.some(selectedRow => 
            (selectedRow.id || selectedRow.pk || selectedRow.company_id) === (row.id || row.pk || row.company_id)
          )
        );
      });

      if (failedDeletes.length > 0) {
        toast.current?.show({ 
          severity: 'warn', 
          summary: 'Partial Delete', 
          detail: `${selectedCompanies.length - failedDeletes.length} companies deleted. ${failedDeletes.length} failed.` 
        });
      } else {
        toast.current?.show({ 
          severity: 'success', 
          summary: 'Success', 
          detail: `${selectedCompanies.length} companies deleted successfully.` 
        });
      }

      // Clear selection
      setSelectedCompanyData([]);

    } catch (error) {
      console.error('Error in bulk delete:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to delete companies. Please try again.'
      });
    }
  };

  // Handle bulk status change from More dropdown
  const handleBulkChangeStatus = async (selectedCompanies, newStatus) => {
    if (!selectedCompanies || selectedCompanies.length === 0) {
      toast.current?.show({
        severity: 'warn',
        summary: 'No Selection',
        detail: 'Please select companies to change status.'
      });
      return;
    }

    try {
      const failedUpdates = [];
      
      for (const company of selectedCompanies) {
        const id = company.id || company.pk || company.company_id;
        if (!id) {
          console.warn('Skipping status update for company without id', company);
          failedUpdates.push({ company, reason: 'no id' });
          continue;
        }
        
        try {
          const updateData = { ...company, status: newStatus };
          const res = await updateCompany(id, updateData);
          
          if (res && (res.status_code === 200 || res.status === 200 || res.id)) {
            console.log(`Updated status for company id=${id} to ${newStatus}`);
          } else {
            failedUpdates.push({ company, reason: res?.message || 'API error' });
            console.error(`Failed to update status for company id=${id}:`, res);
          }
        } catch (err) {
          failedUpdates.push({ company, reason: err?.message || 'Exception' });
          console.error(`Failed to update status for company id=${id}:`, err);
        }
      }

      // Update local state for successfully updated companies
      const successfulUpdates = selectedCompanies.filter(
        company => !failedUpdates.some(failed => 
          (failed.company.id || failed.company.pk || failed.company.company_id) === 
          (company.id || company.pk || company.company_id)
        )
      );

      if (successfulUpdates.length > 0) {
        setCompanyData(prevData => {
          return prevData.map(row => {
            const isUpdated = successfulUpdates.some(updated => 
              (updated.id || updated.pk || updated.company_id) === (row.id || row.pk || row.company_id)
            );
            return isUpdated ? { ...row, status: newStatus } : row;
          });
        });

        setCustomers(prevData => {
          return prevData.map(row => {
            const isUpdated = successfulUpdates.some(updated => 
              (updated.id || updated.pk || updated.company_id) === (row.id || row.pk || row.company_id)
            );
            return isUpdated ? { ...row, status: newStatus } : row;
          });
        });
      }

      if (failedUpdates.length > 0) {
        toast.current?.show({ 
          severity: 'warn', 
          summary: 'Partial Update', 
          detail: `${successfulUpdates.length} companies updated. ${failedUpdates.length} failed.` 
        });
      } else {
        toast.current?.show({ 
          severity: 'success', 
          summary: 'Success', 
          detail: `Status changed to ${newStatus} for ${selectedCompanies.length} companies.` 
        });
      }

      // Clear selection
      setSelectedCompanyData([]);

    } catch (error) {
      console.error('Error in bulk status change:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to change status. Please try again.'
      });
    }
  };

  // Handle bulk attach documents from More dropdown
  const handleBulkAttachDocuments = async (selectedCompanies, attachmentData) => {
    if (!selectedCompanies || selectedCompanies.length === 0) {
      toast.current?.show({
        severity: 'warn',
        summary: 'No Selection',
        detail: 'Please select companies to attach documents.'
      });
      return;
    }

    try {
      const { documentType, subject, files } = attachmentData;
      const failedAttachments = [];
      let totalAttached = 0;

      for (const company of selectedCompanies) {
        const id = company.id || company.pk || company.company_id;
        if (!id) {
          console.warn('Skipping document attachment for company without id', company);
          failedAttachments.push({ company, reason: 'no id' });
          continue;
        }
        
        try {
          // Attach each file to the company
          for (const file of files) {
            console.log(`Attaching document to company id=${id}:`, file.name);
            
            // Create FormData for file upload
            const formData = new FormData();
            formData.append('file', file);
            formData.append('type', documentType.name || documentType.code);
            formData.append('description', subject);
            formData.append('name', file.name);
            
            const res = await createEntityDocument('companies', id, formData);
            
            if (res && (res.id || res.status === 201 || res.status_code === 201)) {
              console.log(`Document attached successfully to company id=${id}`);
              totalAttached++;
            } else {
              failedAttachments.push({ 
                company, 
                fileName: file.name, 
                reason: res?.message || 'Document upload failed' 
              });
              console.error(`Failed to attach document to company id=${id}:`, res);
            }
          }
        } catch (err) {
          failedAttachments.push({ 
            company, 
            fileName: files.map(f => f.name).join(', '), 
            reason: err?.message || 'Exception' 
          });
          console.error(`Failed to attach documents to company id=${id}:`, err);
        }
      }

      if (failedAttachments.length > 0) {
        const successCount = selectedCompanies.length * files.length - failedAttachments.length;
        toast.current?.show({ 
          severity: 'warn', 
          summary: 'Partial Success', 
          detail: `${successCount} documents attached. ${failedAttachments.length} failed.` 
        });
      } else {
        toast.current?.show({ 
          severity: 'success', 
          summary: 'Success', 
          detail: `Documents attached successfully to ${selectedCompanies.length} companies.` 
        });
      }

      // Clear selection
      setSelectedCompanyData([]);

    } catch (error) {
      console.error('Error in bulk document attachment:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to attach documents. Please try again.'
      });
    }
  };

  // More Actions handlers end


  

  // short form starts
  const [categories] = useState([
    {
      key: "0",
      label: "Skills",
      children: [
        {
          key: "0-0",
          label: "Frontend",
          children: [
            { key: "0-0-0", label: "React" },
            { key: "0-0-1", label: "Angular" },
            { key: "0-0-2", label: "Bootstrap" },
          ],
        },
        {
          key: "0-1",
          label: "Backend",
          children: [
            { key: "0-1-0", label: "Python" },
            { key: "0-1-1", label: "Java" },
            { key: "0-1-2", label: "C#" },
          ],
        },
        {
          key: "0-2",
          label: "QA",
          children: [
            { key: "0-2-0", label: "Manual" },
            { key: "0-2-1", label: "Automation" },
          ],
        },
      ],
    },
  ])

  const [selectedCategoryKey, setSelectedCategoryKey] = useState(null)

  //groups

  const [groups] = useState([
    {
      key: "0",
      label: "Skills",
      children: [
        {
          key: "0-0",
          label: "Frontend",
          children: [
            { key: "0-0-0", label: "React" },
            { key: "0-0-1", label: "Angular" },
            { key: "0-0-2", label: "Bootstrap" },
          ],
        },
        {
          key: "0-1",
          label: "Backend",
          children: [
            { key: "0-1-0", label: "Python" },
            { key: "0-1-1", label: "Java" },
            { key: "0-1-2", label: "C#" },
          ],
        },
        {
          key: "0-2",
          label: "QA",
          children: [
            { key: "0-2-0", label: "Manual" },
            { key: "0-2-1", label: "Automation" },
          ],
        },
      ],
    },
  ])

  const [selectedGroupKey, setSelectedGroupKey] = useState(null)

  // short form ends

  // Export code start

  const [importCsvIcons, setImportCsvIcons] = useState(false)
  const dtImport = useRef(null)

  const exportCSVBtn = selectionOnly => {
    if (dtImport.current) {
      dtImport.current.exportCSV({ selectionOnly })
    } else {
      alert("DataTable reference not found.")
    }
  }

  const exportPdfBtn = () => {
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default("landscape")

        // Extract headers from DataTable columns
        const exportColumns = [
          "Company",
          "Website",
          "Industry",
          "Company Size",
          "Year Founded",
          "Email",
          "Mobile Phone",
          "Address",
          "Notes",
          "Category",
          "Group",
          "User IDs",
          "Created By",
          "Last Activity Date",
          "Create Date",
          "Edit Date",
        ]

        // Map data fields to match DataTable
        const exportData = companyData.map(row => [
          row.company || "-",
          row.website || "-",
          row.industry || "-",
          row.companySize || "-",
          row.yearFounded || "-",
          row.email || "-",
          row.mobilePhone || "-",
          row.address || "-",
          row.notes || "-",
          row.category || "-",
          row.group || "-",
          row.userIds || "-",
          row.createdBy || "-",
          row.lastActivityDate || "-",
          row.createDate || "-",
          row.editDate || "-",
        ])

        console.log("Export Columns:", exportColumns)
        console.log("Export Data:", exportData)

        if (exportColumns.length === 0 || exportData.length === 0) {
          alert("No data available for export.")
          return
        }

        doc.autoTable({
          head: [exportColumns],
          body: exportData,
          startY: 20,
          styles: { fontSize: 8, cellPadding: 2 },
          theme: "grid",
          margin: { top: 10, left: 5, right: 5 },
          columnStyles: { 0: { cellWidth: 30 } },
        })

        doc.save("company_data.pdf")
      })
    })
  }

  const exportExcelBtn = () => {
    import("xlsx").then(xlsx => {
      const exportData = companyData.map(row => ({
        Company: row.company || "-",
        Website: row.website || "-",
        Industry: row.industry || "-",
        "Company Size": row.companySize || "-",
        "Year Founded": row.yearFounded || "-",
        Email: row.email || "-",
        "Mobile Phone": row.mobilePhone || "-",
        Address: row.address || "-",
        Notes: row.notes || "-",
        Category: row.category || "-",
        Group: row.group || "-",
        "User IDs": row.userIds || "-",
        "Created By": row.createdBy || "-",
        "Last Activity Date": row.lastActivityDate || "-",
        "Create Date": row.createDate || "-",
        "Edit Date": row.editDate || "-",
      }))

      const worksheet = xlsx.utils.json_to_sheet(exportData)
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] }
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      })

      saveAsExcelFile(excelBuffer, "company_data")
    })
  }

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then(module => {
      if (module && module.default) {
        const EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        const EXCEL_EXTENSION = ".xlsx"
        const data = new Blob([buffer], { type: EXCEL_TYPE })

        module.default.saveAs(
          data,
          `${fileName}_export_${new Date().getTime()}${EXCEL_EXTENSION}`
        )
      }
    })
  }

  const headerBtn = (
    <div className="flex align-items-center justify-content-end gap-1 actionitem-import">
      <Button
        className="csvbtn p-button"
        icon="pi pi-file"
        rounded
        onClick={() => exportCSVBtn(false)}
        tooltip="Export to CSV"
      />
      <Button
        className="xlsbtn p-button"
        icon="pi pi-file-excel"
        severity="success"
        rounded
        onClick={exportExcelBtn}
        tooltip="Export to Excel"
      />
      <Button
        className="pdfbtn p-button me-2"
        icon="pi pi-file-pdf"
        severity="warning"
        rounded
        onClick={exportPdfBtn}
        disabled={companyData.length === 0}
        tooltip="Export to PDF"
      />
    </div>
  )

  // Export code end



  

  const priorityValue = [
    { name: "Low", value: "low" },
    { name: "Medium", value: "medium" },
    { name: "High", value: "high" },
  ]

  // view pages input values

  const [company1, setCompany1] = useState("")
  const [website1, setWebsite1] = useState("")
  const [email1, setEmail1] = useState()
  const [phno1, setPhno1] = useState("")
  const [yearfounded1, setYearfounded1] = useState("")
  const [specialties1, setSpecialties1] = useState("")
  const [industry1, setIndustry1] = useState("")
  const [companysize1, setCompanysize1] = useState("")
  const [categories1, setCategories1] = useState("")
  const [groups1, setGroups1] = useState("")
  const [userid1, setUserid1] = useState("")
  const [address1, setAddress1] = useState("")
  const [notes1, setNotes1] = useState(
    "Varun Digital Media is a digital marketing agency specializing in SEO, social media marketing, and website development. They help businesses enhance their online presence and drive growth across various industries."
  )
  const [overview1, setOverview1] = useState("" )
  const [categoryValue, setCategoryValue] = useState("")
  const [groupValue, setGroupValue] = useState("")

  // Use loaded categories, fallback to hardcoded for backward compatibility
  const categoryOptions = useMemo(() => {
    return categoriesitem.length > 0 ? categoriesitem.map(item => ({
      id: item.id,
      name: item.value || item.name || item.label,
      value: item.id,
      raw: item
    })) : [
      { id: null, name: "Micro Enterprise", value: "micro" },
      { id: null, name: "Small Enterprise", value: "small" },
      { id: null, name: "Medium Enterprise", value: "medium" },
      { id: null, name: "Large Enterprise", value: "large" },
    ];
  }, [categoriesitem]);


  // Use loaded groups, fallback to hardcoded for backward compatibility
  const groupOptions = useMemo(() => {
    return groupitem.length > 0 ? groupitem.map(item => ({
      label: item.value || item.name,
      value: item.id,
      id: item.id
    })) : [
      { label: "Up to 5 Crore", value: "5cr" },
      { label: "Up to 50 Crore", value: "50cr" },
      { label: "Up to 250 Crore", value: "250cr" },
      { label: "Above 250 Crore", value: "above250cr" },
    ];
  }, [groupitem]);


  


  // contacts short form starts

  const companyOptions = [
    { name: "Varun Digital Media", code: "VDM" },
    { name: "Pranathi Software Services", code: "PSS" },
    { name: "Green Ventures pvt Ltd", code: "GV" },
    { name: "Future Tech Solutions", code: "FTS" },
    { name: "Healthify Solutions pvt Ltd", code: "MS" },
  ]

  const [selectedDepartment, setSelectedDepartment] = useState(null)

  const departmentOptions = [
    { name: "Account Finance Team", code: "HR" },
    { name: "SPG US Staffing", code: "FIN" },
    { name: "Vitel Development Team", code: "MKT" },
    { name: "Support Team", code: "ENG" },
    { name: "NOC Team", code: "SAL" },
    { name: "Digital Marketing Team", code: "DIG" },
    { name: "Executive Team", code: "EXE" },
    { name: "Operations Team", code: "OPE" },
  ]

  const [selectedPerson, setSelectedPerson] = useState(null)


  // contacts short form ends

  // State for uploaded files during company creation
  const [uploadedFiles, setUploadedFiles] = useState([]);
  // Use ref to store actual File objects to prevent serialization issues
  const uploadedFilesRef = useRef([]);
  
  // Custom file handler that bypasses PrimeReact issues
  const handleCustomFileSelection = (files) => {
    console.log("Custom file handler - raw files:", files);
    const filesArray = Array.from(files);
    console.log("Custom file handler - files array:", filesArray);
    
    // Validate files
    const validFiles = filesArray.filter(file => {
      console.log(`Validating file:`, file);
      console.log(`File instanceof File:`, file instanceof File);
      console.log(`File name:`, file.name);
      console.log(`File size:`, file.size);
      console.log(`File type:`, file.type);
      
      // Test FormData creation immediately
      try {
        const testFormData = new FormData();
        testFormData.append('test_file', file, file.name);
        const retrievedFile = testFormData.get('test_file');
        console.log(`FormData test for ${file.name}:`, retrievedFile instanceof File ? 'SUCCESS' : 'FAILED');
        if (!(retrievedFile instanceof File)) {
          console.error(`FormData test failed for ${file.name}:`, retrievedFile);
          return false;
        }
      } catch (formDataError) {
        console.error(`FormData test error for ${file.name}:`, formDataError);
        return false;
      }
      
      return file instanceof File && file.name && file.size >= 0;
    });
    
    console.log(`Valid files count: ${validFiles.length} out of ${filesArray.length}`);
    
    if (validFiles.length > 0) {
      // Clear previous files and set new ones
      setUploadedFiles(validFiles);
      uploadedFilesRef.current = validFiles;
      
      console.log("Files stored in state:", validFiles);
      console.log("Files stored in ref:", uploadedFilesRef.current);
      
      toast.current?.show({
        severity: "success",
        summary: "Files Selected",
        detail: `${validFiles.length} file(s) selected successfully`,
      });
    } else {
      toast.current?.show({
        severity: "error",
        summary: "File Selection Failed",
        detail: "No valid files could be processed. Please try again.",
      });
    }
  };

  // more attachment
  const onFileSelect = (event) => {
    console.log("PrimeReact onFileSelect - event:", event);
    console.log("PrimeReact onFileSelect - event.files:", event.files);
    
    if (event.files && event.files.length > 0) {
      handleCustomFileSelection(event.files);
    }
  }
  
  // Helper function to create and validate FormData
  const createValidatedFormData = (file, description) => {
    console.log("Creating FormData for file:", file);
    console.log("File validation check:");
    console.log("- instanceof File:", file instanceof File);
    console.log("- file.name:", file.name);
    console.log("- file.size:", file.size);
    console.log("- file.type:", file.type);
    console.log("- file.lastModified:", file.lastModified);
    console.log("- file constructor:", file.constructor.name);
    
    if (!(file instanceof File)) {
      // Try to recover if it's a File-like object
      if (file && file.name && file.size !== undefined && file.type !== undefined) {
        console.warn("File object appears corrupted, attempting to reconstruct...");
        try {
          // This won't work perfectly but it's worth trying
          const blob = new Blob([file], { type: file.type });
          const newFile = new File([blob], file.name, { 
            type: file.type,
            lastModified: file.lastModified || Date.now()
          });
          console.log("Reconstructed file:", newFile);
          file = newFile;
        } catch (reconstructError) {
          console.error("Failed to reconstruct file:", reconstructError);
          throw new Error(`Invalid file object - not an instance of File: ${typeof file}`);
        }
      } else {
        throw new Error(`Invalid file object - not an instance of File: ${typeof file}`);
      }
    }
    
    if (!file.name) {
      throw new Error("File has no name");
    }
    
    if (file.size === undefined || file.size < 0) {
      throw new Error("File has invalid size");
    }
    
    // Create FormData with more explicit approach
    const formData = new FormData();
    
    // Try multiple ways to append the file
    console.log("Attempting to append file to FormData...");
    try {
      // Method 1: Standard append with filename
      formData.append('file', file, file.name);
      console.log("File appended successfully using method 1");
    } catch (appendError) {
      console.error("Method 1 failed, trying method 2:", appendError);
      try {
        // Method 2: Append without explicit filename
        formData.append('file', file);
        console.log("File appended successfully using method 2");
      } catch (appendError2) {
        console.error("Method 2 failed, trying method 3:", appendError2);
        // Method 3: Create new blob and file
        const blob = new Blob([file], { type: file.type });
        const newFile = new File([blob], file.name, { type: file.type });
        formData.append('file', newFile, file.name);
        console.log("File appended successfully using method 3");
      }
    }
    
    formData.append('description', description);
    
    // Validate FormData immediately after creation
    console.log("FormData validation after creation:");
    try {
      const formDataFile = formData.get('file');
      console.log("- FormData file:", formDataFile);
      console.log("- FormData file instanceof File:", formDataFile instanceof File);
      console.log("- FormData file instanceof Blob:", formDataFile instanceof Blob);
      console.log("- FormData file name:", formDataFile?.name);
      console.log("- FormData file size:", formDataFile?.size);
      console.log("- FormData file type:", formDataFile?.type);
      console.log("- FormData description:", formData.get('description'));
      
      // Additional FormData inspection
      console.log("All FormData entries:");
      for (let [key, value] of formData.entries()) {
        console.log(`FormData[${key}]:`, value, typeof value);
        if (value instanceof File) {
          console.log(`  -> File details: ${value.name}, ${value.size} bytes, ${value.type}`);
        }
      }
      
      if (!formDataFile) {
        throw new Error("FormData validation failed - no file found");
      }
      
      if (!(formDataFile instanceof File) && !(formDataFile instanceof Blob)) {
        throw new Error("FormData validation failed - file is neither File nor Blob");
      }
      
    } catch (validationError) {
      console.error("FormData validation error:", validationError);
      throw new Error("FormData validation failed: " + validationError.message);
    }
    
    return formData;
  };

  const onUpload = (event) => {
    // This is called when using uploadHandler with customUpload
    console.log("Upload handler called:", event);
    // For custom upload, we don't actually upload here - just store the files
    const files = Array.from(event.files || []);
    console.log("Files from upload handler:", files);
    
    // Store these files as well
    files.forEach((file, index) => {
      console.log(`Upload handler file ${index}:`, file);
      console.log(`Upload handler file ${index} instanceof File:`, file instanceof File);
    });
  }
  
  // Handle file removal
  const onRemoveFile = (fileToRemove) => {
    console.log("Removing file:", fileToRemove.name);
    
    // Remove from state
    setUploadedFiles(prevFiles => 
      prevFiles.filter(file => file !== fileToRemove)
    );
    
    // Remove from ref
    uploadedFilesRef.current = uploadedFilesRef.current.filter(file => file !== fileToRemove);
    console.log("Files remaining in ref:", uploadedFilesRef.current);
  }
  
  // more attachment
useEffect(()=>
  {
    if (apiStatus === true) {
      setSelectedCompanyData([]);
    }
  },[apiStatus])
  const getDocumentTypes = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=work_type_document`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      if (response.status === 200) {
        const results = response.data?.results?.results || response.data?.results || [];
        const mapped = results.map((item) => ({
          id: item.id,
          name: (item.value || '').replace(/_/g, ' ').replace(/\b\w/g, (ch) => ch.toUpperCase())
        }));
        setDocumentTypes(mapped);
      }
    } catch (err) {
      console.error('Failed to load document types', err);
    }
  }
  useEffect(() => {
    getDocumentTypes();
  }, []);
  const [FileNames, setFileNames] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedDocId, setSelectedDocId] = useState(null);
  const handleEdit = (doc) => {
    console.log('Editing document:', doc);

    setDisplayDialog(true);
    setSelectedDocId(doc.id);
    setIsEdit(true);
    setSubject(doc.description);
    setSelectedDocument(doc.type || null);
    const LastFiles = Array.isArray(doc.files)
      ? doc.files.map((fileItem, index) => ({
        id: `${doc.id}-${index}`,
        selectedId: fileItem.id,
        name: fileItem.original_filename,
        url: fileItem.file,
      }))
      : doc.files
        ? [{ id: doc.id, name: doc.files.original_filename, url: doc.files.file }]
        : [];

    setFileNames(LastFiles);
  };

  const handleDelete = async (rowKey) => {
    console.log('Deleting document with key:', rowKey);

    try {
      const id = EditId;
      const response = await axios.delete(`${process.env.REACT_APP_Company_Contact}/company/worktypes/${id}/documents/${rowKey}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        getDocuments()
        toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Document deleted successfully', life: 3000 });
      }
    } catch (err) {
      console.log(err);

    }
  }
  useEffect(() => {
    if (selectedCompanyData.length === 1) {
      getDocuments()
    }
  }, [selectedCompanyData]);
  console.log('Selected Document Type:', selectedCompanyData);
  
   const handleAddDocument = async () => {
      if (!selectedDocument || !subject) {
        toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please fill all the fields.' });
        return;
      }
  
      try {
        const formData = new FormData();
        const workTypeId = selectedCompanyData[0]?.id ;
        
        // Document type and description
        formData.append('type', selectedDocument);
        formData.append('description', subject);
  
        // Append uploaded files
        if (uploadedFiles && uploadedFiles.length > 0) {
          uploadedFiles.forEach((file) => {
            formData.append('uploaded_files', file);
          });
        }
  
        // Send request
        const response = await axios.post(
          `${process.env.REACT_APP_Company_Contact}/company/worktypes/${workTypeId}/documents/`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        
        if (response.status === 201 || response.status === 200) {
          // Reload documents and reset state
          getDocuments(workTypeId);
          setDisplayDialog(false);
          setSelectedDocument(null);
          setSubject('');
          setUploadedFiles([]);
          toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Document added successfully' });
        }
  
      } catch (err) {
        console.error('Failed to upload document', err);
        toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to upload document' });
      }
    };
  
  const handleUpdateDocument = async () => {
    if (!selectedDocument || !subject) {
      alert('Please fill all the fields.');
      return;
    }

    try {
      const EditId = selectedCompanyData[0]?.id;

      const formData = new FormData();

      // Document type
      const docTypeObj = documentTypes.find(dt => dt.id === selectedDocument);
      const docTypeName = docTypeObj ? docTypeObj.name : selectedDocument;
      formData.append('type', selectedDocument);
      formData.append('description', subject);

      // Append newly uploaded files
      if (uploadedFiles && uploadedFiles.length > 0) {
        uploadedFiles.forEach((file) => {
          formData.append('uploaded_files', file);
        });
      }
      if (FileNames && FileNames.length > 0) {
        FileNames.forEach((file) => {
          formData.append('files_to_keep', file.selectedId);
        });
      }

      const response = await axios.patch(
        `${process.env.REACT_APP_Company_Contact}/company/worktypes/${EditId}/documents/${selectedDocId}/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      if (response.status == 200 || response.status == 201) {
        setDisplayDialog(false);
        setSelectedDocument(null);
        setSubject('');
        setFileNames([]);
        setUploadedFiles([]);
        setIsEdit(false);
        getDocuments();
      }

      toast.current?.show({ severity: 'success', summary: 'Updated', detail: 'Document updated' });

    } catch (err) {
      console.error('Failed to update document', err);
      alert('Failed to update document');
    }
  };

  return (
    <React.Fragment>
      <div className="page-content allact-tabs">
        <Container fluid={true}>
          <div className="page-title-box actjobbread">
            <Row className="justify-content-between ac-items">
              <Col xxl={9} xl={12} lg={12} md={12} sm={12}>
                <span className="addcan-ac">
                  {selectedCompanyData.length > 0 ? (
                    <span className="action-icons me-2">
                      <button
                        type="button"
                        className="btn btn-secondary import-res-btn me-1 md:w-8rem"
                      >
                        <i className="pi pi-building"></i>{" "}
                        {selectedCompanyData.length} Selected
                      </button>

                      <span className="icons-ac">
                        {selectedCompanyData.length === 1 ? (
                          <>
                            <Tooltip
                              target=".view"
                              content="View"
                              position="bottom"
                              style={{ marginTop: "5px" }}
                            />
                            <button
                              type="button"
                              className="btn btn-secondary icons-btn ms-1 view"
                              onClick={() => {
                                if (selectedCompanyData.length === 1) {
                                  populateViewForm(selectedCompanyData[0]);
                                  setVisibleViewRight(true);
                                }
                              }}
                            >
                              <i className="pi pi-eye"></i>
                            </button>

                            <Tooltip
                              target=".edit"
                              content="Edit"
                              position="top"
                              style={{ marginBottom: "5px" }}
                            />
                            <button
                              type="button"
                              className="btn btn-secondary icons-btn ms-1 edit"
                              onClick={() => {
                                if (selectedCompanyData.length === 1) {
                                  console.log("Edit button clicked - selectedCompanyData:", selectedCompanyData[0]);
                                  navigate("/companies-editform", { state: { companyData: selectedCompanyData[0] } });
                                } else {
                                  toast.current.show({
                                    severity: 'warn',
                                    summary: 'Warning',
                                    detail: 'Please select exactly one company to edit.',
                                    life: 3000
                                  });
                                }
                              }}
                              disabled={selectedCompanyData.length !== 1}
                            >
                              <i className="pi pi-pencil"></i>
                            </button>

                            <Tooltip
                              target=".delete"
                              content="Delete"
                              position="bottom"
                              style={{ marginTop: "5px" }}
                            />

                            <button
                              type="button"
                              className="btn btn-secondary icons-btn ms-1 delete"
                              onClick={handleDeleteSelected}
                            >
                              <i className="pi pi-trash"></i>
                            </button>

                            <Tooltip
                              target=".archived"
                              content="Unarchive"
                              position="top"
                              style={{ marginBottom: "5px" }}
                            />
                            <button
                              type="button"
                              className="btn btn-secondary icons-btn ms-1 archived"
                              onClick={ handleArchiveCompany}
                            >
                              <i className="pi pi-check-circle"></i>
                            </button>
                          </>
                        ) : null}
                      </span>
                    </span>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-secondary import-res-btn md:w-10rem me-1"
                      onClick={() => setVisibleRight(true)}
                    >
                      <i className="pi pi-building me-1"></i> Add a Company
                    </button>
                  )}
                </span>

                <span className="drop-ac">
                  {/* <button
                    type="button"
                    className="btn btn-secondary import-res-btn  ms-1  me-1"
                  >
                    Submit Candidate
                  </button> */}

                  <AddContact company={selectedCompanyData} apiStatus={apiCallStatus} />

                  {/* <CascadeSelect
                    onChange={handleScheduleChange}
                    options={actScheduleOptions}
                    optionLabel="name"
                    optionGroupLabel="name"
                    className="md:w-10rem me-1"
                    optionGroupChildren={['subItems', 'subItems']}
                    breakpoint="767px"
                    placeholder="Schedule"
                  /> */}
                  <MoreACcompanies 
                    selectedCompanies={selectedCompanyData}
                    onDeleteCompanies={handleBulkDeleteCompanies}
                    onAttachDocuments={handleBulkAttachDocuments}
                    onChangeStatus={handleBulkChangeStatus}
                    toast={toast}
                  />
                </span>
              </Col>

              <Col xxl={3} xl={12} lg={12} sm={12}>
                <div className="clr-icons">
                  {selectedCompanyData.length > 0 ? (
                    <NotesCompanies1  data={selectedCompanyData[0]}/>
                  ) : (
                    <NotesCompanies data={selectedCompanyData[0]} />
                  )}

                  <Tooltip
                    target=".export"
                    content="Export"
                    position="bottom"
                    style={{ marginTop: "5px" }}
                  />

                  <button
                    type="button"
                    className="btn btn-secondary icons-btn me-1 export"
                    onClick={() => setImportCsvIcons(!importCsvIcons)}
                  >
                    <i className="pi pi-file-export"></i>
                  </button>

                  {importCsvIcons && <span>{headerBtn}</span>}

                  <Tooltip
                    target=".clear"
                    content="Clear Search"
                    position="bottom"
                    style={{ marginTop: "5px" }}
                  />

                  <button
                    type="button"
                    className="btn btn-secondary icons-btn me-1 clear"
                    Tooltip="Clear Search"
                    onClick={handleClearSearchCompanies}
                  >
                    <i className="pi pi-sync"></i>
                  </button>
                </div>
              </Col>
            </Row>

            <Row>
              <Col sm={12}>
                {/* <Tooltip target="span[data-pr-tooltip]" /> */}

                <section className="allactjobs-table">
                  {/* Toast for notifications */}
                  <Toast ref={toast} />

                  {/* ContextMenu for right-click actions */}
                  <ContextMenu
                    model={menuModel}
                    ref={cm}
                    onHide={() => setSelectedCompany(null)}
                  />

                  <div className="card1 mt-4 mb-4 actjobsumtable">
                    <DataTable
                      ref={dtImport}
                      value={companyData.slice(pageState.first, pageState.first + pageState.rows)}
                      rows={pageState.rows}
                      first={pageState.first}
                      onPage={onPage}
                      loading={loading}
                      // selection={selectedCompanyData}
                      onSelectionChange={e => setSelectedCompanyData(e.value)}
                      selectionMode="multiple"
                      filters={filters}
                      filterDisplay="row"
                      scrollable
                      selection={selectedCompanyData}
                      resizableColumns
                      reorderableColumns
                      onContextMenu={e => {
                        cm.current.show(e.originalEvent) // Show the context menu
                        setSelectedCompany(e.data) // Set the selected company
                      }}
                      contextMenuSelection={selectedCompany}
                      onContextMenuSelectionChange={e =>
                        setSelectedCompany(e.value)
                      }
                    >
                      <Column
                        selectionMode="multiple"
                        headerStyle={{ width: "3em" }}
                      />
                      <Column
                        field="company"
                        header="Company"
                        sortable
                        filter
                      />
                      <Column
                        field="website"
                        header="Website"
                        sortable
                        filter
                      />
                      <Column
                        field="industry"
                        header="Industry"
                        sortable
                        filter
                        body={(rowData) => {
                          if (!rowData) return "";
                          const val = rowData.industry;
                          if (!val && val !== 0) return "";

                          // If the industry is an object, prefer common display fields.
                          if (typeof val === "object")
                            return val.name || val.value || val.label || String(val.id || "");

                          // Try to resolve primitive IDs or slug values using the loaded industries lookup.
                          try {
                            if (Array.isArray(industries) && industries.length) {
                              const found = industries.find(it =>
                                // match by id (number or string), by value, or by name
                                (it.id !== undefined && String(it.id) === String(val)) ||
                                (it.value !== undefined && String(it.value) === String(val)) ||
                                (it.name !== undefined && String(it.name) === String(val))
                              );
                              if (found) return found.value || found.name || String(found.id);
                            }
                          } catch (err) {
                            // ignore and fall back
                            console.warn('Industry resolver error', err);
                          }

                          // Fallback to showing the raw primitive
                          return String(val);
                        }}
                      />
                      <Column
                        field="companySize"
                        header="Company Size"
                        sortable
                        filter
                        body={(rowData) => {
                          if (!rowData.companySize) return '';
                          // If it's already a string (name), return it
                          if (typeof rowData.companySize === 'string' && isNaN(rowData.companySize)) {
                            return rowData.companySize;
                          }
                          // If it's an ID, look up the corresponding name
                          const sizeOption = companySizeOptions.find(option => 
                            option.id === rowData.companySize || 
                            option.id === Number(rowData.companySize) ||
                            option.code === rowData.companySize
                          );
                          return sizeOption ? sizeOption.name : rowData.companySize;
                        }}
                      />
                      <Column
                        field="yearFounded"
                        header="Year Founded"
                        sortable
                        filter
                      />
                      {/* <Column field="overview" header="Overview" sortable filter /> */}
                      <Column field="email" header="Email" sortable filter />
                      <Column
                        field="mobilePhone"
                        header="Mobile Phone"
                        sortable
                        filter
                      />
                      <Column
                        field="address"
                        header="Address"
                        sortable
                        filter
                      />
                      {/* <Column
                        field="notes"
                        header="Notes"
                        sortable
                        filter
                        body={subjectTemplate}
                      /> */}
                      <Column
                        field="category"
                        header="Category"
                        sortable
                        filter
                        body={(rowData) => {
                          if (!rowData.category) return '';
                          // If it's already a string (name), return it
                          if (typeof rowData.category === 'string' && isNaN(rowData.category)) {
                            return rowData.category;
                          }
                          // If it's an ID, look up the corresponding name
                          let categoryOption = null;
                          
                          // Try categoryOptionsState first
                          if (categoryOptionsState && categoryOptionsState.length > 0) {
                            categoryOption = categoryOptionsState.find(option => 
                              option.id === rowData.category || 
                              option.id === Number(rowData.category) ||
                              option.code === rowData.category ||
                              option.value === rowData.category
                            );
                          }
                          
                          // Fallback to categoryOptions
                          if (!categoryOption && categoryOptions && categoryOptions.length > 0) {
                            categoryOption = categoryOptions.find(option => 
                              option.id === rowData.category || 
                              option.id === Number(rowData.category) ||
                              option.code === rowData.category ||
                              option.value === rowData.category ||
                              option.label === rowData.category
                            );
                          }
                          
                          return categoryOption ? categoryOption.name : rowData.category;
                        }}
                      />
                      <Column
                        field="group"
                        header="Group"
                        sortable
                        filter
                        body={(rowData) => {
                          if (!rowData.group) return '';
                          // If it's already a string (name), return it
                          if (typeof rowData.group === 'string' && isNaN(rowData.group)) {
                            return rowData.group;
                          }
                          // If it's an ID, look up the corresponding name
                          let groupOption = null;
                          
                          // Try groupOptionsState first
                          if (groupOptionsState && groupOptionsState.length > 0) {
                            groupOption = groupOptionsState.find(option => 
                              option.id === rowData.group || 
                              option.id === Number(rowData.group) ||
                              option.code === rowData.group ||
                              option.value === rowData.group
                            );
                          }
                          
                          // Fallback to groupOptions
                          if (!groupOption && groupOptions && groupOptions.length > 0) {
                            groupOption = groupOptions.find(option => 
                              option.id === rowData.group || 
                              option.id === Number(rowData.group) ||
                              option.code === rowData.group ||
                              option.value === rowData.group ||
                              option.label === rowData.group
                            );
                          }
                          
                          return groupOption ? groupOption.name : rowData.group;
                        }}
                      />
                      {/* <Column
                        field="userIds"
                        header="User IDs"
                        sortable
                        filter
                      /> */}
                      <Column
                        field="createdBy"
                        header="Created By"
                        sortable
                        filter
                        body={(rowData) => {
                          if (!rowData) return "";
                          // Prefer mapped createdBy (already a string/object)
                          const candidate = rowData.createdBy ?? rowData.created_by ?? rowData.created_by_name ?? rowData.created_by_display;
                          if (candidate === undefined || candidate === null) return "";
                          // If it's an object, return the most likely display field
                          if (typeof candidate === 'object') return candidate.name || candidate.username || candidate.display || JSON.stringify(candidate);

                          // Try resolving numeric/string id against known local user lists (PrivetDropdown) if available
                          try {
                            if (Array.isArray(PrivetDropdown) && PrivetDropdown.length) {
                              const found = PrivetDropdown.find(u => String(u.id) === String(candidate) || String(u.name) === String(candidate) || String(u.code) === String(candidate));
                              if (found) return found.name || found.label || String(found.id);
                            }
                          } catch (err) {
                            console.warn('CreatedBy resolver error', err);
                          }

                          // Final fallback to existing mapped string or raw value
                          return String(candidate);
                        }}
                      />
                      {/* <Column
                        field="lastActivityDate"
                        header="Last Activity Date"
                        sortable
                        filter
                      /> */}
                      <Column
                        field="createDate"
                        header="Create Date"
                        sortable
                        filter
                      />
                      <Column
                        field="editDate"
                        header="Edit Date"
                        sortable
                        filter
                      />
                    </DataTable>

                    {/* Confirmation Dialog */}
                    <Dialog
                      visible={showConfirmDialog}
                      style={{ width: "450px" }}
                      header="Confirm Deletion"
                      modal
                      footer={
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={cancelDelete}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger ms-2"
                            onClick={confirmDelete}
                          >
                            Delete
                          </button>
                        </div>
                      }
                      onHide={() => setShowConfirmDialog(false)}
                    >
                      <p>
                        Are you sure you want to delete{" "}
                        {/* {selectedTableData.length > 1 ? "items" : "item"} of type{" "} */}
                        <strong>{selectedCompanyData[0]?.type}</strong>?
                      </p>
                    </Dialog>
                  </div>
                </section>
              </Col>
            </Row>

            {/* Side bar start */}
            <Row>
              <Col lg={12}>
                <Sidebar
                  visible={visibleRight}
                  position="right"
                  className="sidebar"
                  onHide={() => setVisibleRight(false)}
                >
                  <div className="sidebar-header">
                    <h3>Create a Company</h3>
                    <div className="d-flex align-items-center">
                      {/* <Link to="/candidate-editform">
                        <p className="mb-0 text-white">
                          {" "}
                          <i class="fa-regular fa-pen-to-square me-3"></i>{" "}
                        </p>
                      </Link> */}
                      <Tooltip
                        target=".closeside"
                        content="Close"
                        position="bottom"
                        style={{ marginBottom: "5px" }}
                      />
                      {/* <Link to="/companies-editform">
                        <p className="mb-0 text-white">
                          {" "}
                          <i class="fa-regular fa-pen-to-square me-3"></i>{" "}
                        </p>
                      </Link> */}
                      <Button
                        icon="pi pi-times"
                        className="p-button-text close-btn closeside"
                        onClick={() => setVisibleRight(false)}
                      />
                    </div>
                  </div>
                  <div className="card sidebardetails">
                    <Row className="mb-2">
                      <Col lg={6}>
                        <div className="p-field">
                          <label htmlFor="company">Company</label>
                          <InputText
                            aria-label="Default select example"
                            value={company1}
                            onChange={e => setCompany1(e.target.value)}
                            placeholder="Enter company name"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="p-field">
                          <label htmlFor="website">Website</label>
                          <InputText
                            id="website"
                            value={website1}
                            onChange={e => setWebsite1(e.target.value)}
                            placeholder="Enter website URL"
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col lg={6}>
                        <div className="p-field">
                          <label htmlFor="work-email">Email</label>
                          <InputText 
                            placeholder="Enter email" 
                            value={email1} 
                            onChange={e => setEmail1(e.target.value)}
                          />
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="p-field">
                          <label htmlFor="phoneNumber">Phone Number</label>
                          <InputText
                            placeholder="Enter phone number"
                            value={phno1}
                            onChange={e => setPhno1(e.target.value)}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col lg={12}>
                        <div
                          className="p-field companie-add"
                          style={{ position: "relative" }}
                        >
                          <label htmlFor="address">Address</label>
                          <InputTextarea
                            id="address"
                            value={address}
                            onChange={e => setAddress(e.target.value)}
                            placeholder="Enter your address"
                            style={{ paddingRight: "2rem" }} // Optional styling
                            rows={8} // Specify number of rows
                            cols={30} // Specify width
                            readOnly
                          />
                          {/* Edit Icon */}
                          <i
                            className="pi pi-pencil"
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "70%",
                              transform: "translateY(-50%)",
                              color: "#6c757d",
                              cursor: "pointer",
                            }}
                            onClick={() => setVisible(true)}
                          ></i>
                          <Dialog
                            header="Edit Address"
                            className="address-popup"
                            visible={visible}
                            onHide={() => {
                              setVisible(false);
                              setStreet1('');
                              setStreet2('');
                              setSelectedCity(null);
                              setSelectedState(null);
                              setSelectedCountry(null);
                              setPostalCode('');
                              setSelectedLabel(null);
                              setAddress('');
                            }}
                            style={{ width: "30vw" }}
                            breakpoints={{
                              "960px": "75vw",
                              "641px": "100vw",
                            }}
                          >
                            <div className="card sidebardetails">
                              <form>
                                <Row className="mb-3">
                                  <Col lg={6}>
                                    <div className="p-field">
                                      <label htmlFor="street1">Street 1</label>
                                      <InputText
                                        id="street1"
                                        value={street1}
                                        onChange={e => {
                                          setStreet1(e.target.value)
                                          updateAddress()
                                        }}
                                        placeholder=""
                                        className="w-full activejobdrop"
                                      />
                                    </div>
                                  </Col>
                                  <Col lg={6}>
                                    <label htmlFor="street2">Street 2</label>
                                    <InputText
                                      id="street2"
                                      value={street2}
                                      onChange={e => {
                                        setStreet2(e.target.value)
                                        updateAddress()
                                      }}
                                      placeholder="Enter Street 2 (Optional)"
                                      className="w-full activejobdrop"
                                    />
                                  </Col>
                                </Row>

                                <Row className="mb-3">
                                  <Col lg={6}>
                                    <label htmlFor="city">City</label>
                                    <Dropdown
                                      id="city"
                                      value={selectedCity}
                                      onChange={e => {
                                        updateAddress()
                                        setSelectedCity(e.value)
                                      }}
                                      options={addCities}
                                      optionLabel="name"
                                      filter
                                      filterPlaceholder="Search City"
                                      className="w-full activejobdrop"
                                      placeholder="Hyderabad"
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <label htmlFor="state">State</label>
                                    <Dropdown
                                      id="state"
                                      value={selectedState}
                                      onChange={e => {
                                        updateAddress()
                                        setSelectedState(e.value)
                                      }}
                                      options={addStates}
                                      optionLabel="name"
                                      filter
                                      filterPlaceholder="Search State"
                                      className="w-full activejobdrop"
                                      placeholder="Telangana"
                                    />
                                  </Col>
                                </Row>

                                <Row className="mb-3">
                                  <Col lg={6}>
                                    <label htmlFor="country">Country</label>
                                    <Dropdown
                                      id="country"
                                      value={selectedCountry}
                                      onChange={e => {
                                        updateAddress()
                                        setSelectedCountry(e.value)
                                      }}
                                      options={addCountries}
                                      optionLabel="name"
                                      filter
                                      filterPlaceholder="Search Country"
                                      className="w-full activejobdrop"
                                      placeholder="India"
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <label htmlFor="zipCode">
                                     Zip Code
                                    </label>
                                    <InputText
                                      id="postalCode"
                                      value={postalCode}
                                      onChange={e => {
                                        updateAddress()
                                        setPostalCode(e.target.value)
                                      }}
                                      placeholder=""
                                      className="w-full activejobdrop"
                                    />
                                  </Col>
                                </Row>

                                <Row className="mb-3">
                                  <Col lg={12}>
                                    <label htmlFor="postalCode">Label</label>
                                    <Dropdown
                                      value={selectedLabel}
                                      onChange={e => {
                                        updateAddress()
                                        setSelectedLabel(e.value)
                                      }}
                                      options={labels}
                                      optionLabel="name"
                                      placeholder="Work From Office"
                                      className="w-full activejobdrop"
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <Button
                                      type="button"
                                      color="primary"
                                      className="btn btn-primary waves-effect waves-light me-2 sidebarbtn"
                                      onClick={() => { setVisible(false); }}
                                    >
                                      <i className="pi pi-check me-1"></i> Save
                                    </Button>

                                    <Button
                                      type="button"
                                      color="primary"
                                      className="btn btn-primary waves-effect waves-light cancelbtn me-2"
                                      onClick={() => {
                                        setVisible(false);
                                        setStreet1('');
                                        setStreet2('');
                                        setSelectedCity(null);
                                        setSelectedState(null);
                                        setSelectedCountry(null);
                                        setPostalCode('');
                                        setSelectedLabel(null);
                                        setAddress('');
                                      }}
                                    >
                                      <i className="pi pi-times me-1"></i>
                                      Cancel
                                    </Button>
                                  </Col>
                                </Row>
                              </form>
                            </div>
                          </Dialog>
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col lg={6}>
                        <div className="p-field">
                          <label htmlFor="yearFounded">Year Founded</label>
                          <Calendar
                            id="year"
                            value={year}
                            onChange={e => setYear(e.value)}
                            view="year"
                            dateFormat="yy"
                            yearRange="2000:2030"
                            placeholder="Select Year"
                            className="w-full"
                            showIcon
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="p-field">
                          <label>Specialties</label>
                          <InputText
                            placeholder="Enter specialties"
                            className="w-full activejobdrop"
                            value={specialties1}
                            onChange={e => setSpecialties1(e.target.value)}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col lg={6}>
                        <div className="p-field">
                          <label htmlFor="industry">Industry</label>
                            <Dropdown
                              id="industry"
                              value={industry}
                              onChange={e => {
                                setIndustry(e.value)
                                // if a real industry object is chosen, store its id for edit
                                const val = e.value
                                if (val && val.id && val.id !== 'add' && val.id !== 'edit') setLastSelectedIndustryId(val.id)
                              }}
                              options={[...industries, { id: 'add', name: 'Add New', icon: 'pi pi-plus' }, ...(industry ? [{ id: 'edit', name: 'Edit Selected', icon: 'pi pi-pencil' }] : [])]}
                              optionLabel="name"
                              filter
                              filterPlaceholder="Search Industry"
                              className="w-full activejobdrop"
                              placeholder="Select Industry"
                              itemTemplate={(option) => (
                                <div className="flex align-items-center gap-2">
                                  {option && option.icon && <i className={option.icon} />}
                                  <span>{option && (option.name || option.value)}</span>
                                </div>
                              )}
                            />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="p-field">
                          <label htmlFor="companySize">Company Size</label>
                          <Dropdown
                            id="companySize"
                            value={companySize}
                            onChange={e => setCompanySize(e.value)}
                            options={companySizeOptions}
                            optionLabel="name"
                            filter
                            filterPlaceholder="Search Company Size"
                            className="w-full activejobdrop"
                            placeholder=" Select Company Size"
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col lg={12}>
                        <div className="">
                          <label htmlFor="description">Overview</label>
                          <InputTextarea
                            autoResize
                            rows={4}
                            cols={40}
                            placeholder="Enter a description..."
                            value={overview1}
                            onChange={e => setOverview1(e.target.value)}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col lg={6}>
                        <div className="p-field">
                          <label htmlFor="company">Categories</label>
                            <Dropdown
                              id="category"
                              value={selectedCategory1}
                              onChange={e => {
                                setSelectedCategory1(e.value)
                                const val = e.value
                                if (val && (val.id ?? val) !== 'add' && (val.id ?? val) !== 'edit') {
                                  setLastSelectedCategoryId(val.id ?? val)
                                }
                              }}
                              options={[...(categoryOptionsState.length ? categoryOptionsState : categoryOptions), { id: 'add', name: 'Add New', icon: 'pi pi-plus' }, ...(selectedCategory1 ? [{ id: 'edit', name: 'Edit Selected', icon: 'pi pi-pencil' }] : [])]}
                              optionLabel="name"
                              placeholder="Select Category"
                              className="w-full bgclr"
                              itemTemplate={(option) => (
                                <div className="flex align-items-center gap-2">
                                  {option && option.icon && <i className={option.icon} />}
                                  <span>{option && (option.name || option.value)}</span>
                                </div>
                              )}
                            />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="p-field">
                          <label htmlFor="company">Group</label>
                          <Dropdown
                            id="group"
                            value={selectedGroup1}
                            onChange={e => setSelectedGroup1(e.value)}
                            options={[
                              ...(groupOptionsState && groupOptionsState.length ? groupOptionsState : []),
                              { id: 'add', name: 'Add New', icon: 'pi pi-plus' },
                              ...(selectedGroup1 ? [{ id: 'edit', name: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                            ]}
                            optionLabel="name"
                            placeholder="Select Group"
                            className="w-full bgclr"
                            itemTemplate={(option) => (
                              <div className="flex align-items-center gap-2">
                                {option?.icon && <i className={option.icon}></i>}
                                <span>{option.name || option.value || option.label}</span>
                              </div>
                            )}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col lg={12}>
                        <div className="p-field">
                          <label htmlFor="Attach Document">Attach Document</label>
                          
                          {/* Primary HTML file input - more reliable than PrimeReact */}
                          <div className="mt-2">
                            {/* <input
                              type="file"
                              multiple
                              accept="image/*,application/pdf,.doc,.docx,.txt,.xls,.xlsx"
                              className="form-control"
                              onChange={(e) => {
                                console.log("HTML file input change event:", e.target.files);
                                if (e.target.files && e.target.files.length > 0) {
                                  handleCustomFileSelection(e.target.files);
                                }
                              }}
                            /> */}
                            <FileUpload
                              ref={fileUploadRef}
                              name="documents[]"
                              accept="image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                              maxFileSize={5242880}
                              multiple
                              customUpload
                              auto
                              onSelect={(e) => {
                                // Get current files (previously uploaded ones)
                                const currentFiles = uploadedFiles || [];
                                
                                // Validate individual file types first for new files
                                const allowedTypes = [
                                  'image/jpg', 'image/jpeg', 'image/png', 
                                  'application/pdf',
                                  'application/msword', // .doc
                                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                                  'text/plain', // .txt
                                  'application/vnd.ms-excel', // .xls
                                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // .xlsx
                                ];
                                
                                const validNewFiles = e.files.filter(file => allowedTypes.includes(file.type));
                                const invalidFiles = e.files.filter(file => !allowedTypes.includes(file.type));
                                
                                if (invalidFiles.length > 0) {
                                  toast.current?.show({
                                    severity: "error",
                                    summary: "Invalid File Type",
                                    detail: `File(s) rejected: ${invalidFiles.map(f => f.name).join(', ')}. Only Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX are allowed.`,
                                    life: 5000
                                  });
                                  
                                  // If there are valid files, continue with them; otherwise clear and return
                                  if (validNewFiles.length === 0) {
                                    // Clear the component and restore previous files
                                    setTimeout(() => {
                                      if (fileUploadRef.current) {
                                        fileUploadRef.current.clear();
                                        // Restore previous files to the component
                                        if (currentFiles.length > 0) {
                                          fileUploadRef.current.setFiles(currentFiles);
                                        }
                                      }
                                    }, 0);
                                    return;
                                  }
                                }
                                
                                // Combine current files with valid new files
                                const allFiles = [...currentFiles, ...validNewFiles];
                                
                                // Calculate total size of all files (current + new valid files)
                                const totalSize = allFiles.reduce((sum, file) => sum + file.size, 0);
                                const maxTotalSize = 5242880; // 5MB total limit (5 * 1024 * 1024)
                                const totalSizeMB = totalSize / (1024 * 1024);
                                
                                console.log(`File validation - Current files: ${currentFiles.length}, New files: ${validNewFiles.length}, Total files: ${allFiles.length}, Total size: ${totalSizeMB.toFixed(3)}MB, Limit: ${(maxTotalSize / (1024 * 1024)).toFixed(1)}MB`);
                                
                                if (totalSize > maxTotalSize) {
                                  const currentSizeMB = currentFiles.reduce((sum, file) => sum + file.size, 0) / (1024 * 1024);
                                  const newSizeMB = validNewFiles.reduce((sum, file) => sum + file.size, 0) / (1024 * 1024);
                                  
                                  toast.current?.show({
                                    severity: "error",
                                    summary: "File Size Error",
                                    detail: `Cannot add ${validNewFiles.length} file(s) (${newSizeMB.toFixed(2)}MB). Current files: ${currentSizeMB.toFixed(2)}MB, Total would be: ${totalSizeMB.toFixed(2)}MB. Maximum allowed: 5MB.`,
                                    life: 5000
                                  });
                                  
                                  // Clear the component and restore only previous files
                                  setTimeout(() => {
                                    if (fileUploadRef.current) {
                                      fileUploadRef.current.clear();
                                      // Restore only the previous files, not the new ones
                                      if (currentFiles.length > 0) {
                                        fileUploadRef.current.setFiles(currentFiles);
                                      }
                                    }
                                  }, 0);
                                  return;
                                }
                                
                                // Success - files are valid
                                toast.current?.show({
                                  severity: "success",
                                  summary: "Files Added",
                                  detail: `${validNewFiles.length} file(s) added. Total: ${allFiles.length} files (${totalSizeMB.toFixed(2)}MB)`,
                                  life: 3000
                                });
                                
                                setUploadedFiles(allFiles);
                                console.log(`Upload ready - Total files: ${allFiles.length}, Total size: ${totalSizeMB.toFixed(3)}MB`);
                              }}
                              uploadHandler={(e) => {
                                // This will be called when files are manually uploaded
                                console.log('Upload handler called', e.files);
                              }}
                              onClear={() => {
                                console.log("Files cleared")
                                setUploadedFiles([])
                              }}
                            />
                            <small className="text-muted">
                              Maximum total file size: 5MB. Accepted formats: Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX
                            </small>
                            
                            {/* Debug button to test file integrity */}
                            {/* {uploadedFiles.length > 0 && (
                              <div className="mt-2">
                                <Button
                                  type="button"
                                  className="btn btn-sm btn-outline-info"
                                  onClick={() => {
                                    console.log("=== COMPREHENSIVE FILE TEST ===");
                                    console.log("State files:", uploadedFiles);
                                    console.log("Ref files:", uploadedFilesRef.current);
                                    
                                    uploadedFilesRef.current.forEach((file, index) => {
                                      console.log(`\n--- Testing File ${index}: ${file.name} ---`);
                                      console.log(`File:`, file);
                                      console.log(`instanceof File:`, file instanceof File);
                                      console.log(`name:`, file.name);
                                      console.log(`size:`, file.size);
                                      console.log(`type:`, file.type);
                                      
                                      // Test 1: Basic FormData creation
                                      try {
                                        console.log("Test 1: Basic FormData creation");
                                        const testFormData1 = new FormData();
                                        testFormData1.append('file', file, file.name);
                                        testFormData1.append('description', `Test file ${file.name}`);
                                        
                                        const retrievedFile = testFormData1.get('file');
                                        console.log(`Retrieved file:`, retrievedFile);
                                        console.log(`Retrieved instanceof File:`, retrievedFile instanceof File);
                                        console.log(`Retrieved name:`, retrievedFile?.name);
                                        console.log(`Retrieved size:`, retrievedFile?.size);
                                        
                                        if (retrievedFile instanceof File) {
                                          console.log("✅ Test 1 PASSED");
                                        } else {
                                          console.error("❌ Test 1 FAILED - not a File object");
                                        }
                                      } catch (error) {
                                        console.error("❌ Test 1 ERROR:", error);
                                      }
                                      
                                      // Test 2: Using our validation function
                                      try {
                                        console.log("Test 2: Using validation function");
                                        const validatedFormData = createValidatedFormData(file, `Test validation for ${file.name}`);
                                        console.log("✅ Test 2 PASSED - validation function succeeded");
                                        
                                        // Test what we get back
                                        const validatedFile = validatedFormData.get('file');
                                        console.log("Validated file:", validatedFile);
                                        console.log("Validated file instanceof File:", validatedFile instanceof File);
                                        
                                      } catch (error) {
                                        console.error("❌ Test 2 FAILED:", error);
                                      }
                                      
                                      // Test 3: Simulate axios request payload
                                      try {
                                        console.log("Test 3: Axios payload simulation");
                                        const axiosTestData = new FormData();
                                        axiosTestData.append('file', file, file.name);
                                        axiosTestData.append('description', `Axios test for ${file.name}`);
                                        
                                        // Log what axios would receive
                                        console.log("Axios would receive FormData with:");
                                        for (let [key, value] of axiosTestData.entries()) {
                                          console.log(`${key}:`, value, typeof value);
                                          if (value instanceof File) {
                                            console.log(`  File details: ${value.name}, ${value.size} bytes, ${value.type}`);
                                          }
                                        }
                                        console.log("✅ Test 3 COMPLETED");
                                      } catch (error) {
                                        console.error("❌ Test 3 ERROR:", error);
                                      }
                                    });
                                    console.log("=== END COMPREHENSIVE TEST ===");
                                  }}
                                >
                                  Test File Integrity
                                </Button>
                              </div>
                            )} */}
                          </div>
                          
                          {/* Backup PrimeReact FileUpload (hidden by default) */}
                          <div className="mt-2" style={{display: 'none'}}>
                            {/* <FileUpload
                              name="documents[]"
                              multiple
                              accept="image/*,application/pdf,.doc,.docx,.txt,.xls,.xlsx"
                              maxFileSize={5000000}
                              onSelect={onFileSelect}
                              mode="basic"
                              chooseLabel="Select Files (Backup)"
                              className="mt-2"
                              auto={false}
                              customUpload={true}
                            /> */}
                            <FileUpload
                              ref={fileUploadRef}
                              name="documents[]"
                              accept="image/jpg,image/jpeg,image/png,application/pdf"
                              maxFileSize={5000000}
                              multiple
                              customUpload
                              auto
                              uploadHandler={(e) => {
                                setUploadedFiles(e.files)
                              }}
                              onClear={() => {
                                console.log("Files cleared")
                                setUploadedFiles([])
                              }}
                            />
                          </div>
                          
                          {/* Display uploaded files */}
                          {/* {uploadedFiles && uploadedFiles.length > 0 && (
                            <div className="mt-2">
                              <label>Uploaded Files:</label>
                              <ul className="list-group">
                                {uploadedFiles.map((file, index) => (
                                  <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                    <span>
                                      <i className="pi pi-file mr-2"></i>
                                      {file.name} ({(file.size / 1024).toFixed(1)} KB)
                                    </span>
                                    <Button
                                      icon="pi pi-times"
                                      className="p-button-danger p-button-text p-button-sm"
                                      onClick={() => onRemoveFile(file)}
                                      tooltip="Remove file"
                                    />
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )} */}
                        </div>
                      </Col>
                    </Row>





                    <Row className="align-items-end justify-content-start mb-2 mt-2">
                      <Col lg={2}>
                        <div className="p-field d-flex align-items-center">
                          <Checkbox
                            inputId="privateCheckbox"
                            checked={privateDrop}
                            onChange={(e) => setPrivateDrop(e.checked)}
                          />
                          <label htmlFor="privateCheckbox" className="ms-2">Private</label>
                        </div>
                      </Col>
                      <Col lg={6}>
                        {privateDrop && (
                          <div className="p-field">
                            <MultiSelect
                              value={PrivetDropdown}
                              onChange={(e) => setPrivetDropdown(e.value)}
                              options={PrivetDropdownValues}
                              // optionLabel="name"
                              optionLabel={option => `${option.name} (${option.email})`}
                              display="comma"
                              placeholder="Select User Id's"
                              className="w-full"
                              maxSelectedLabels={8}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>

                    <Row>
                      <Col lg={12}>
                        <div className="d-flex justify-content-end gap-2">
                          <Button
                            color="secondary"
                            className="btn btn-secondary waves-effect waves-light me-2"
                            onClick={() => {
                              resetCompanyForm();
                              setVisibleRight(false);
                            }}
                            disabled={loading}
                          >
                            Cancel
                          </Button>
                          <Button
                            color="primary"
                            className="btn btn-primary waves-effect waves-light sidebarbtn"
                            onClick={handleCreateCompany}
                            loading={loading}
                            disabled={loading}
                          >
                            {loading ? "Creating..." : "Create"}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Sidebar>
              </Col>
            </Row>
            {/* Side bar end */}
          </div>
        </Container>
      </div>

      {/* view page starts */}
      <Row>
        <Col lg={12}>
          <Sidebar
            visible={visibleViewRight}
            position="right"
            onHide={handleCloseViewSidebar}
            className="view-form-sidebar"
          >
            <div className="sidebar-header">
              <h3 className="head">
                <i className="pi pi-building"></i> Company - {company1 || 'Company Details'}
              </h3>
              <div className="d-flex align-items-center">
                {/* <Link to="/candidate-editform">
                  <p className="mb-0 text-white">
                    <i class="fa-regular fa-pen-to-square me-3"></i>
                  </p>
                </Link> */}
                <Button
                  icon="pi pi-times"
                  className="p-button-text close-btn"
                  onClick={handleCloseViewSidebar}
                />
              </div>
            </div>
            <TabView className="mt-4">
              <TabPanel header="Profile" leftIcon="pi pi-user mr-2">
                <Row>
                  <Col lg={12}>
                    <Accordion multiple activeIndex={[0, 1]}>
                      <AccordionTab
                        header={
                          <span className="flex align-items-center gap-2 w-full">
                            <span className="white-space-nowrap">
                              PROFILE INFORMATION
                            </span>
                            <Badge value="-" className="ml-auto" />
                          </span>
                        }
                      >
                        <Row className="mb-2">
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="company" className="block">
                                Company
                              </label>
                              <InputText
                                id="company"
                                placeholder=""
                                className="block w-full"
                                value={company1}
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="website" className="block">
                                Website
                              </label>
                              <InputText
                                id="website"
                                type="url"
                                placeholder=""
                                className="block w-full"
                                value={website1}
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="email" className="block">
                                Email
                              </label>
                              <InputText
                                id="email"
                                type="email"
                                placeholder=""
                                className="block w-full"
                                value={email1}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row className="mb-2">
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="phone" className="block">
                                Phone Number
                              </label>
                              <InputText
                                id="phone"
                                type="tel"
                                placeholder=""
                                className="block w-full"
                                value={phno1}
                              />
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="yearFounded" className="block">
                                Year Founded
                              </label>
                              <InputText
                                id="yearFounded"
                                type="number"
                                placeholder="Select Year"
                                className="block w-full"
                                value={yearfounded1}
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="specialties" className="block">
                                Specialties
                              </label>
                              <InputText
                                id="specialties"
                                placeholder=""
                                className="block w-full"
                                value={specialties1}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="industry" className="block">
                                Industry
                              </label>
                              <InputText
                                id="industry"
                                placeholder=""
                                className="block w-full"
                                value={(() => {
                                  if (!industry1) return '';
                                  // If it's already a readable string (not numeric), return it
                                  if (typeof industry1 === 'string' && isNaN(industry1)) {
                                    return industry1;
                                  }
                                  // If it's an ID, look up the corresponding name
                                  const industryOption = industries.find(option => 
                                    option.id === industry1 || 
                                    option.id === Number(industry1) ||
                                    option.code === industry1 ||
                                    option.value === industry1
                                  );
                                  return industryOption ? industryOption.name : industry1;
                                })()}
                                readOnly
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="companySize" className="block">
                                Company Size
                              </label>
                              <InputText
                                id="companySize"
                                placeholder=""
                                className="block w-full"
                                value={(() => {
                                  if (!companysize1) return '';
                                  // If it's already a readable string (not numeric), return it
                                  if (typeof companysize1 === 'string' && isNaN(companysize1)) {
                                    return companysize1;
                                  }
                                  // If it's an ID, look up the corresponding name
                                  const sizeOption = companySizeOptions.find(option => 
                                    option.id === companysize1 || 
                                    option.id === Number(companysize1) ||
                                    option.code === companysize1 ||
                                    option.value === companysize1
                                  );
                                  return sizeOption ? sizeOption.name : companysize1;
                                })()}
                                readOnly
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="categories" className="block">
                                Categories
                              </label>
                              <InputText
                                id="categories"
                                placeholder=""
                                className="block w-full"
                                value={(() => {
                                  if (!categoryValue) return '';
                                  // If it's already a readable string (not numeric), return it
                                  if (typeof categoryValue === 'string' && isNaN(categoryValue)) {
                                    return categoryValue;
                                  }
                                  // If it's an ID, look up the corresponding name
                                  let categoryOption = null;
                                  
                                  // Try categoryOptionsState first
                                  if (categoryOptionsState && categoryOptionsState.length > 0) {
                                    categoryOption = categoryOptionsState.find(option => 
                                      option.id === categoryValue || 
                                      option.id === Number(categoryValue) ||
                                      option.code === categoryValue ||
                                      option.value === categoryValue
                                    );
                                  }
                                  
                                  // Fallback to categoryOptions
                                  if (!categoryOption && categoryOptions && categoryOptions.length > 0) {
                                    categoryOption = categoryOptions.find(option => 
                                      option.id === categoryValue || 
                                      option.id === Number(categoryValue) ||
                                      option.code === categoryValue ||
                                      option.value === categoryValue ||
                                      option.label === categoryValue
                                    );
                                  }
                                  
                                  return categoryOption ? categoryOption.name : categoryValue;
                                })()}
                                readOnly
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row className="mb-2 align-items-end">
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="groups" className="block">
                                Groups
                              </label>
                              <InputText
                                id="groups"
                                placeholder=""
                                className="block w-full"
                                value={(() => {
                                  if (!groupValue) return '';
                                  // If it's already a readable string (not numeric), return it
                                  if (typeof groupValue === 'string' && isNaN(groupValue)) {
                                    return groupValue;
                                  }
                                  // If it's an ID, look up the corresponding name
                                  let groupOption = null;
                                  
                                  // Try groupOptionsState first
                                  if (groupOptionsState && groupOptionsState.length > 0) {
                                    groupOption = groupOptionsState.find(option => 
                                      option.id === groupValue || 
                                      option.id === Number(groupValue) ||
                                      option.code === groupValue ||
                                      option.value === groupValue
                                    );
                                  }
                                  
                                  // Fallback to groupOptions
                                  if (!groupOption && groupOptions && groupOptions.length > 0) {
                                    groupOption = groupOptions.find(option => 
                                      option.id === groupValue || 
                                      option.id === Number(groupValue) ||
                                      option.code === groupValue ||
                                      option.value === groupValue ||
                                      option.label === groupValue
                                    );
                                  }
                                  
                                  return groupOption ? groupOption.name : groupValue;
                                })()}
                                readOnly
                              />
                            </div>
                          </Col>
                          {/* <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="userIds" className="block">
                                User IDs
                              </label>
                              <InputText
                                id="userIds"
                                placeholder=""
                                className="block w-full"
                                value={userid1}
                              />
                            </div>
                          </Col> */}
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="address" className="block">
                                Private Users
                              </label>
                              <InputText
                                id="address"
                                placeholder=""
                                className="block w-full"
                                value={privateUserValues}
                                readOnly
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row className="mb-2">
                          <Col lg={6}>
                            <div className="p-field">
                              <label htmlFor="address" className="block">
                                Address
                              </label>
                              <InputTextarea
                                id="address"
                                rows={3}
                                placeholder="White house, Block - III, 4th Floor, Begumpet, Hyderabad, Telangana, 500016, India"
                                className="block w-full"
                                value={address}
                              />
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div className="p-field">
                              <label htmlFor="overview" className="block">
                                Overview
                              </label>
                              <InputTextarea
                                id="overview"
                                rows={3}
                                placeholder="Varun Digital Media is a digital marketing agency specializing in SEO, social media marketing, and website development. They help businesses enhance their online presence."
                                className="block w-full"
                                value={overview1}
                              />
                            </div>
                          </Col>
                        </Row>

                      
                      </AccordionTab>
                      <AccordionTab
                        header={
                          <span className="flex align-items-center gap-2 w-full">
                            {/* <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/onyamalimba.png" shape="circle" /> */}
                            <span className="white-space-nowrap">
                              DOCUMENTS
                            </span>
                            <Badge 
                              value={loadingDocuments ? "..." : documents.length} 
                              className="ml-auto" 
                            />
                          </span>
                        }
                      >
                        <Row>
                          <Col lg={12}>
                            {loadingDocuments ? (
                              <div className="flex justify-content-center align-items-center p-4">
                                <i className="pi pi-spin pi-spinner mr-2"></i>
                                <span>Loading documents...</span>
                              </div>
                            ) : documents.length === 0 ? (
                              <div className="flex justify-content-center align-items-center p-4 text-muted">
                                <i className="pi pi-file mr-2"></i>
                                <span>No documents found for this company</span>
                              </div>
                            ) : (
                                  <div className="doc-table">
                                    <DataTable
                                      value={documents}
                                      rows={5}
                                      className="p-datatable-gridlines"
                                      emptyMessage={<div className="empty-message-custom">No documents found.</div>}
                                    >
                                      <Column
                                        field="type_name"
                                        header="Document Type"
                                      />
                                      <Column
                                        field="description"
                                        header="Subject"
                                      />
                                      <Column
                                        field="created_at"
                                        header="Uploaded On"
                                        body={(rowData) => new Date(rowData.created_at).toLocaleDateString()}
                                      />
                                      <Column
                                        header="Attachments"
                                        body={(rowData) => rowData.files && rowData.files.length > 0 ? (
                                          <ul className="list-unstyled mb-0">
                                            {rowData.files.map((fileItem) => (
                                              <li key={fileItem.id}>
                                                <a href={fileItem.file} target="_blank" rel="noopener noreferrer">
                                                  {fileItem.original_filename} ({(fileItem.file_size / 1024).toFixed(2)} KB)
                                                </a>
                                              </li>
                                            ))}
                                          </ul>
                                        ) : 'No file'}
                                      />
                                      <Column
                                        header="Actions"
                                        body={(rowData) => (
                                          <div className="d-flex gap-2">
                                            <Button
                                              type="button"
                                              icon="pi pi-pencil"
                                              tooltip="Edit"
                                              onClick={() => handleEdit(rowData)}
                                            />
                                            <Button
                                              icon="pi pi-trash"
                                              tooltip="Delete"
                                              type="button"
                                              onClick={() => handleDelete(rowData.id)}
                                            />
                                          </div>
                                        )}
                                      />
                                    </DataTable>
                                  </div>
                            )}
                          </Col>
                        </Row>
                      </AccordionTab>
                    </Accordion>
                  </Col>
                </Row>
              </TabPanel>

                <TabPanel header="Projects" leftIcon="pi pi-calendar mr-2">
                <Row>
                  <Col lg={12}>
                    <section className="job-datatable-section">
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                                   <DataTable
                          value={projectData}
                          selection={selectedProjects}
                          onSelectionChange={(e) => setSelectedProjects(e.value)}
                          selectionMode="multiple"
                          filters={projectDataFilters}
                          onFilter={(e) => setProjectDataFilters(e.filters)}
                          filterDisplay="row"
                          loading={projectsLoading}
                          paginator
                          rows={5}
                          rowsPerPageOptions={[5, 10, 25, 50]}
                          responsiveLayout="scroll"
                          showGridlines
                          resizableColumns
                          columnResizeMode="expand"
                          emptyMessage={projectsLoading ? "Loading projects..." : "No projects found for this company."}
                          tableStyle={{
                            minWidth: "120rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <Column selectionMode="multiple" headerStyle={{ width: "3rem" }} />
                          <Column field="project_code" header="Project Code" filter style={{ minWidth: "10rem" }} />
                          <Column field="project_name" header="Project Name" filter style={{ minWidth: "10rem" }} />
                          {/* <Column field="project_manager" header="Project Manager" filter style={{ minWidth: "14rem" }} /> */}
                          {/* <Column field="task_count" header="# Tasks" filter style={{ minWidth: "10rem" }} /> */}
                          {/* <Column field="completed_tasks" header="# Completed Tasks" filter style={{ minWidth: "14rem" }} /> */}
                          
                          
                          {/* <Column
                            field="extended_end_date"
                            header="Extended End Date"
                            filter
                            filterElement={dateFilterTemplate}
                            style={{ minWidth: "14rem" }}
                          /> */}
                         
                          <Column
                            field="project_start_date"
                            header="Project Start Date"
                            filter
                            // filterElement={dateFilterTemplate}
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="project_end_date"
                            header="Project End Date"
                            filter
                            // filterElement={dateFilterTemplate}
                            style={{ minWidth: "10rem" }}
                          />
                          <Column field="status" header="Status" filter style={{ minWidth: "10rem" }} />
                          <Column field="delay_reason" header="Reason for Delay" filter style={{ minWidth: "10rem" }} />
                        </DataTable>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>

              <TabPanel header="Work Type" leftIcon="pi pi-calendar mr-2">
                <Row>
                  <Col lg={12}>
                    <section className="job-datatable-section">
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                        <DataTable
                          value={companyProjects}
                          filters={companyProjectFilters}
                          globalFilterFields={[
                            "task_code",
                            "task_type",
                            "project_name",
                            "project_manager",
                            "module_name",
                            "task_name",
                            "task_description",
                            "created_by",
                            "assigned_by",
                            "assigned_to",
                            "watchers",
                            "start_date",
                            "end_date",
                            "actual_end_date",
                            "work_hours",
                            "task_status",
                            "priority",
                            "approval_status",
                          ]}
                          filterDisplay="row"
                          selection={selectedCompanyProjects}
                          onSelectionChange={e =>
                            setSelectedCompanyProjects(e.value)
                          }
                          selectionMode="multiple"
                          loading={workTypesLoading}
                          paginator
                          rows={5}
                          rowsPerPageOptions={[5, 10, 25, 50]}
                          responsiveLayout="scroll"
                          showGridlines
                          resizableColumns
                          columnResizeMode="expand"
                          emptyMessage={workTypesLoading ? "Loading work types..." : "No work types found for this company."}
                          tableStyle={{
                            minWidth: "120rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <Column
                            selectionMode="multiple"
                            headerStyle={{ width: "3em" }}
                          />
                          <Column
                            field="task_code"
                            header="Work Type Code"
                            style={{ minWidth: "10rem" }}
                            sortable
                            filter
                          />
                          <Column
                            field="task_type"
                            header="Work Type"
                            style={{ minWidth: "10rem" }}
                            sortable
                            filter
                          />
                          {/* <Column
                            field="project_name"
                            header="Project Name"
                            sortable
                            filter
                          />
                          <Column
                            field="project_manager"
                            header="Project Manager"
                            sortable
                            filter
                          />
                          <Column
                            field="module_name"
                            header="Module Name"
                            sortable
                            filter
                          /> */}
                          <Column
                            field="task_name"
                            header="Summary"
                            style={{ minWidth: "10rem" }}
                            sortable
                            filter
                          />
                          {/* <Column
                            field="task_description"
                            header="Task Description"
                            sortable
                            filter
                            style={{ minWidth: "15rem" }}
                          />
                          <Column
                            field="created_by"
                            header="Created By"
                            sortable
                            filter
                          /> */}
                          {/* <Column
                            field="assigned_by"
                            header="Assigned By"
                            sortable
                            filter
                          /> */}
                          <Column
                            field="assigned_to"
                            header="Assigned To"
                            style={{ minWidth: "10rem" }}
                            sortable
                            filter
                          />
                          {/* <Column
                            field="watchers"
                            header="Watchers"
                            sortable
                            filter
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="start_date"
                            header="Start Date"
                            sortable
                            filter
                          />
                          <Column
                            field="end_date"
                            header="End Date"
                            sortable
                            filter
                          />
                          <Column
                            field="actual_end_date"
                            header="Actual End Date"
                            sortable
                            filter
                          />
                          <Column
                            field="work_hours"
                            header="Work Hours"
                            sortable
                            filter
                          /> */}
                          <Column
                            field="task_status"
                            header="Work Type Status"
                            style={{ minWidth: "10rem" }}
                            sortable
                            filter
                          />

                          <Column
                            field="project_name"
                            header="Project Name"
                            style={{ minWidth: "10rem" }}
                            sortable
                            filter
                          />
                          {/* <Column
                            field="priority"
                            header="Priority"
                            sortable
                            filter
                          />
                          <Column
                            field="approval_status"
                            header="Approval Status"
                            sortable
                            filter
                          /> */}
                        </DataTable>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>

            

             

              <TabPanel header="Activities" leftIcon="pi pi-calendar mr-2">
                <Row>
                  <Col lg={12}>
                    <section className="job-datatable-section">
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                        <DataTable
                          responsive
                          showGridlines
                          value={activities}
                          tableStyle={{
                            minWidth: "50rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          paginator
                          rows={5}
                          rowsPerPageOptions={[5, 10, 25, 50]}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          filters={activitiesFilters}
                          filterDisplay="row"
                          globalFilterFields={[
                            "type",
                            "sub_type",
                            "priority",
                            "subject",
                            "date_time",
                            "user_id",
                          ]}
                          emptyMessage="No activities found."
                          selection={selectedActivities}
                          onSelectionChange={e =>
                            setSelectedActivities(e.value)
                          }
                          selectionMode="multiple"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            selectionMode="multiple"
                            headerStyle={{ width: "3em" }}
                          />
                          <Column
                            field="type"
                            header="Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="sub_type"
                            header="Sub Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          {/* <Column
                            field="priority"
                            header="Priority"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          /> */}
                          <Column
                            field="subject"
                            header="Subject"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="date_time"
                            header="Date and Time"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="user_id"
                            header="User ID"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                        </DataTable>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>

              <TabPanel header="History" leftIcon="pi pi-clock mr-2">
                <Row>
                  <Col lg={12} sm={12}>
                    <section className="job-datatable-section">
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                        <DataTable
                          responsive
                          showGridlines
                          value={history}
                          tableStyle={{
                            minWidth: "50rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          paginator
                          rows={5}
                          rowsPerPageOptions={[5, 10, 25, 50]}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          filters={historyFilters}
                          filterDisplay="row"
                          globalFilterFields={[
                            "type",
                            "sub_type",
                            "priority",
                            "subject",
                            "date_time",
                            "user_id",
                          ]}
                          emptyMessage="No history found."
                          selection={selectedHistory}
                          onSelectionChange={e => setSelectedHistory(e.value)}
                          selectionMode="multiple"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            selectionMode="multiple"
                            headerStyle={{ width: "3em" }}
                          />
                          <Column
                            field="type"
                            header="Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="sub_type"
                            header="Sub Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          {/* <Column
                            field="priority"
                            header="Priority"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          /> */}
                          <Column
                            field="subject"
                            header="Subject"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="date_time"
                            header="Date and Time"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="user_id"
                            header="User ID"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                        </DataTable>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel header="Notes" leftIcon="pi pi-pencil mr-2">
                <Row>
                  <Col lg={12}>
                    <div className="d-flex justify-content-end">
                      <Button
                        type="button"
                        label="Add Notes"
                        icon="pi pi-plus"
                        className="btn btn-primary waves-effect waves-light me-2 sidebarbtn"
                        onClick={handleAddNotes}
                        disabled={notesLoading || isEditorVisible}
                      />
                    </div>
                  </Col>
                </Row>

                {isEditorVisible && (
                  <Row className="mt-4">
                    <Col lg={12}>
                      <Editor
                        value={editorContent}
                        onTextChange={e => setEditorContent(e.htmlValue)}
                        style={{ height: "200px" }}
                        placeholder="Enter your notes here..."
                      />
                      <div className="d-flex justify-content-end mt-2">
                        <Button
                          type="button"
                          label={notesLoading ? "Saving..." : "Save"}
                          icon={notesLoading ? "pi pi-spin pi-spinner" : "pi pi-save"}
                          className="btn btn-success me-2"
                          onClick={handleSaveNotes}
                          disabled={notesLoading || !editorContent.trim()}
                        />
                        <Button
                          color="primary"
                          className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                          onClick={handleCancelNotes}
                          disabled={notesLoading}
                        >
                          <i className="pi pi-times me-1"></i>
                          Cancel
                        </Button>
                      </div>
                    </Col>
                  </Row>
                )}

                <Row className="mt-4 notes">
                  <Col lg={12}>
                    {notesLoading ? (
                      <div className="text-center p-4">
                        <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                        <p className="mt-2">Loading notes...</p>
                      </div>
                    ) : candidateNotes.length > 0 ? (
                      <Card className="pt-0 pb-0">
                        {candidateNotes.map((note, index) => (
                          <div key={index}>
                            <div className="d-flex mt-0">
                              <strong className="text-muted me-4">
                                {note.candidateName}
                              </strong>
                              <strong className="text-muted">
                                {note.timestamp}
                              </strong>
                            </div>
                            <div className="d-flex justify-content-between mt-2 mb-0">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: note.content,
                                }}
                              />
                              <div>
                                <Button
                                  icon="pi pi-pencil"
                                  className="btn btn-warning editbtn p-0"
                                  onClick={() => handleEditNote(index)}
                                  disabled={notesLoading || isEditorVisible}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  className="btn btn-danger deletebtn"
                                  onClick={() => handleDeleteNote(index)}
                                  disabled={notesLoading || isEditorVisible}
                                />
                              </div>
                            </div>
                            <hr />
                          </div>
                        ))}
                      </Card>
                    ) : (
                      <div className="text-center p-4">
                        <p className="text-muted">No notes available for this company.</p>
                      </div>
                    )}
                  </Col>
                </Row>
              </TabPanel>
            </TabView>
          </Sidebar>
        </Col>
      </Row>

      {/* Document Edit Dialog */}
      {/* Add/Edit Lookup Dialog (Category / Industry) */}
      <Dialog
        header={
          statusModalContext === 'company_categories' ? (editingStatus ? 'Edit Company Category' : 'Add Company Category') :
          statusModalContext === 'company_industry' ? (editingStatus ? 'Edit Industry' : 'Add Industry') :
          statusModalContext === 'company_group' ? (editingStatus ? 'Edit Group' : 'Add Group') : (editingStatus ? 'Edit' : 'Add')
        }
        visible={statusModalVisible}
        style={{ width: '400px' }}
        modal
        onHide={() => { setStatusModalVisible(false); setEditingStatus(false); setStatusForm('') }}
      >
        <div className="p-fluid">
          {editingStatus && (
            <>
              <label className="mb-1">Select {statusModalContext === 'company_categories' ? 'Category' : statusModalContext === 'company_industry' ? 'Industry' : 'Group'} to edit</label>
              <Dropdown
                value={selectedEditdrop}
                options={selecteddropoptions}
                onChange={(e) => {
                  const selectedObj = selecteddropoptions.find((opt) => opt.id === e.value || opt.code === e.value)
                  setStatusForm(selectedObj ? (selectedObj.name || selectedObj.value) : '')
                  setSelectedEditdrop(selectedObj ? (selectedObj.id ?? selectedObj.code) : null)
                }}
                placeholder="Select to prefill"
                className="w-full bgclr mb-2"
                optionLabel={statusModalContext === 'company_categories' ? 'name' : 'name'}
                optionValue={statusModalContext === 'company_categories' ? 'id' : 'id'}
                filter
              />
            </>
          )}
          <div className="p-field mb-3">
            <label htmlFor="lookupValue">Value</label><span className="text-danger ms-2">*</span>
            <InputText id="lookupValue" value={statusForm} onChange={(e) => setStatusForm(e.target.value)} placeholder="Enter value" />
          </div>
          <div className="p-field mb-3">
            <label htmlFor="lookupDescription">Description</label>
            <InputTextarea id="lookupDescription" value={statusDescription} onChange={(e) => setStatusDescription(e.target.value)} rows={3} placeholder="Enter description (optional)" />
          </div>
        </div>
       <div className="d-flex justify-content-end mt-3">
          <Button label="Cancel" icon="pi pi-times"  className="p-button-text me-2" onClick={() => { setStatusModalVisible(false); setEditingStatus(false); setStatusForm(''); setStatusDescription('') }} />
          <Button label="Save" icon="pi pi-check" className="p-button-primary" onClick={async () => {
            try {
              if (statusModalContext === 'company_categories') {
                await handleLookupSave('company_categories', lastSelectedCategoryId)
              } else if (statusModalContext === 'company_industry') {
                await handleLookupSave('company_industry', lastSelectedIndustryId)
              } else if (statusModalContext === 'company_group') {
                await handleLookupSave('company_group', lastSelectedGroupId)
              }
            } catch (err) {
              console.error('Lookup save failed', err)
            }
            finally {
              setStatusDescription('')
            }
          }} />
        </div>
      </Dialog>
      <Dialog
        header="Edit Document"
        visible={documentEditDialog}
        style={{ width: '500px' }}
        modal
        onHide={() => {
          setDocumentEditDialog(false);
          setEditingDocument(null);
        }}
      >
        <div className="p-fluid">
          <div className="p-field mb-3">
            <label htmlFor="docType" className="p-field-label">
              Document Type
            </label>
            <InputText
              id="docType"
              value={editDocumentData.type}
              onChange={(e) => setEditDocumentData(prev => ({
                ...prev, 
                type: e.target.value
              }))}
              placeholder="Enter document type"
            />
          </div>
          
          <div className="p-field mb-3">
            <label htmlFor="docDescription" className="p-field-label">
              Document Description
            </label>
            <InputTextarea
              id="docDescription"
              value={editDocumentData.description}
              onChange={(e) => setEditDocumentData(prev => ({
                ...prev, 
                description: e.target.value
              }))}
              rows={3}
              placeholder="Enter document description"
            />
          </div>
          
          <div className="p-field mb-3">
            <label htmlFor="docName" className="p-field-label">
              Document Name
            </label>
            <InputText
              id="docName"
              value={editDocumentData.name}
              onChange={(e) => setEditDocumentData(prev => ({
                ...prev, 
                name: e.target.value
              }))}
              placeholder="Enter document name"
            />
          </div>
          
          {editingDocument && editingDocument.fileUrl && (
            <div className="p-field mb-3">
              <label className="p-field-label">Current File</label>
              <div className="flex align-items-center gap-2">
                <i className="pi pi-file"></i>
                <span className="text-sm text-500">
                  {editingDocument.fileName}
                </span>
                <Button
                  icon="pi pi-external-link"
                  className="p-button-text p-button-sm"
                  onClick={() => handleDocumentDownload(editingDocument)}
                  title="View current file"
                />
              </div>
            </div>
          )}
        </div>
        
        <div className="flex justify-content-end gap-2 mt-4">
          <Button
            label="Cancel"
            icon="pi pi-times"
            outlined
            onClick={() => {
              setDocumentEditDialog(false);
              setEditingDocument(null);
            }}
          />
          <Button
            label="Save Changes"
            icon="pi pi-check"
            onClick={handleDocumentUpdate}
          />
        </div>
      </Dialog>

     <Dialog
              header={isEdit ? "Edit Document" : "Add Document"}
              visible={displayDialog}
              onHide={()=>setDisplayDialog(false)}
              style={{ width: "30vw" }}
              footer={
                <div className="d-flex justify-content-end gap-2">
                  {isEdit ? 
                    <Button color="primary btn-main mr-2" onClick={handleUpdateDocument}>
                      <i className="pi pi-pencil me-1"></i>
                      Update
                    </Button> :
                    <Button color="primary btn-main mr-2" onClick={handleAddDocument}>
                      <i className="pi pi-plus me-1"></i>
                      Add Document
                    </Button>
                  }
                  <Button color="btn btn-primary cancel-outlinebtn" onClick={() => setDisplayDialog(false)}>
                    <i className="pi pi-times me-1"></i>
                    Cancel
                  </Button>
                </div>
              }
            >
              <Row className="mt-2 align-items-center">
                <Col xl={3}>
                  <label htmlFor="documentType" className="block mb-2">
                    Document Type
                  </label>
                </Col>
                <Col xl={9}>
                  <Dropdown
                    id="documentType"
                    value={selectedDocument}
                    onChange={(e) => setSelectedDocument(e.value)}
                    options={[
                      ...documentTypes,
                      { id: 'add', name: 'Add New', value: 'Add New', icon: 'pi pi-plus' },
                      ...(selectedDocument ? [{ id: 'edit', name: 'Edit Selected', value: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                    ]}
                    optionLabel="name"
                    optionValue="id"
                    className="w-full bgclr"
                    style={{ border: '1px solid #ced4da' }}
                    placeholder="Select Document Type"
                    itemTemplate={(option) => (
                      <div className="flex align-items-center gap-2">
                        {option?.icon && <i className={option.icon}></i>}
                        <span>{option.name || option.value}</span>
                      </div>
                    )}
                  />
                </Col>
              </Row>
    
              <Row className="mt-2 align-items-center">
                <Col xl={3}>
                  <label htmlFor="documentSubject" className="block mb-2">
                    Document Subject
                  </label>
                </Col>
                <Col xl={9}>
                  <InputText
                    id="documentSubject"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    className="w-full"
                    style={{ border: '1px solid #ced4da' }}
                    placeholder="Enter document subject or description"
                  />
                </Col>
              </Row>
    
              <Row className="mt-2 align-items-center">
                <Col xl={3}>
                  <label htmlFor="documentAttachment" className="block mb-2">
                    File Attachment
                  </label>
                </Col>
                <Col xl={9}>
                  <FileUpload
                    ref={fileUploadRef}
                    name="files[]"
                    accept="image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    maxFileSize={5242880}
                    multiple
                    customUpload
                    auto={false}
                    onSelect={(e) => {
                      const currentFiles = uploadedFiles || [];
                      const newFiles = e.files || [];
                      
                      // Calculate total size including existing files
                      const currentTotalSize = currentFiles.reduce((total, file) => total + (file.size || 0), 0);
                      const newTotalSize = newFiles.reduce((total, file) => total + (file.size || 0), 0);
                      const totalSize = currentTotalSize + newTotalSize;
                      
                      // Check total size limit (5MB = 5,242,880 bytes)
                      if (totalSize > 5242880) {
                        toast.current?.show({ 
                          severity: 'error', 
                          summary: 'File Size Error', 
                          detail: `Total file size exceeds 5MB limit. Current total: ${(totalSize / 1024 / 1024).toFixed(2)}MB` 
                        });
                        
                        // Clear the new selection but preserve existing files
                        if (fileUploadRef.current) {
                          fileUploadRef.current.clear();
                          if (currentFiles.length > 0) {
                            fileUploadRef.current.setFiles(currentFiles);
                          }
                        }
                        return;
                      }
                      
                      // Check file types
                      const allowedTypes = [
                        'image/jpeg', 'image/jpg', 'image/png',
                        'application/pdf',
                        'application/msword',
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        'text/plain',
                        'application/vnd.ms-excel',
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                      ];
                      
                      const invalidFiles = newFiles.filter(file => !allowedTypes.includes(file.type));
                      if (invalidFiles.length > 0) {
                        toast.current?.show({ 
                          severity: 'error', 
                          summary: 'Invalid File Type', 
                          detail: `Invalid file types: ${invalidFiles.map(f => f.name).join(', ')}. Only Images, PDF, DOC, DOCX, TXT, XLS, XLSX are allowed.` 
                        });
                        
                        // Clear the new selection but preserve existing files
                        if (fileUploadRef.current) {
                          fileUploadRef.current.clear();
                          if (currentFiles.length > 0) {
                            fileUploadRef.current.setFiles(currentFiles);
                          }
                        }
                        return;
                      }
                      
                      // All validations passed, update the files
                      const combinedFiles = [...currentFiles, ...newFiles];
                      setUploadedFiles(combinedFiles);
                    }}
                    uploadHandler={(e) => {
                      console.log("Upload handler called", e.files);
                    }}
                    onClear={() => {
                      console.log("Files cleared");
                      setUploadedFiles([]);
                    }}
                  />
                  <small className="text-muted">
                    Maximum total file size: 5MB. Accepted formats: Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX
                  </small>
                </Col>
              </Row>
              
              {FileNames && FileNames.length > 0 && (
                <Row className="mt-2 align-items-center">
                  <Col xl={3}>
                    <label className="block mb-2">Previously Attached Files</label>
                  </Col>
                  <Col xl={9}>
                    {FileNames.map((file) => (
                      <div key={file.id} className="d-flex align-items-center mb-2">
                        <a
                          href={file.url || file.name}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="me-2"
                        >
                          {file.name.split('/').pop()}
                        </a>
                        <i
                          className="pi pi-times"
                          style={{ cursor: "pointer", color: "red" }}
                          onClick={() => {
                            setFileNames(prev => prev.filter(f => f.id !== file.id));
                          }}
                        ></i>
                      </div>
                    ))}
                  </Col>
                </Row>
              )}
            </Dialog>
    </React.Fragment>
  )
}
export default CompanyArchived
